let designtype = false;
let grt_photo_id = "";
let ordername = "";
let ratio_width   =   0;
let ratio_height  =   0;
let file_width_global = 0;
let file_height_global = 0;
let uploadedFileWidth = 0;
let uploadedFileHeight = 0;
currentSelectedOption = 'custom';
selectedItemNo = 1;
anotherTransfer = false;
let customItemHTML = '';
let popularItemHTML = '';
var onePercentOfPreview = 11.36363636363636;
let isReadyToPress = false;
let anotherPuff = false;
let definedMinQty = 1;
let isAIImage = false;
let isAIEdit  = false;     // ✅ new
let aiOriginalUrl = '';    // ✅ nano-banana URL for _Original Image
let isFileUpload = false;
let beforeUpScale__Width = 0;
let beforeUpScale__height = 0;
window.__aiEditOriginalUrl = '';
let precutOptionAvailable = false;
let isLastMinumum = 249;
if ( typeof isPuffProduct !== 'undefined' && isPuffProduct ) {
  definedMinQty = 10;
} else if ( typeof isSpangleProduct !== 'undefined' && isSpangleProduct ) {
  definedMinQty = 6;
} else if ( typeof isCustomStickerProduct !== 'undefined' && isCustomStickerProduct ) {
  definedMinQty = 100;
} else if ( typeof isBumperStickerProduct !== 'undefined' && isBumperStickerProduct && typeof definedQty__metafield !== 'undefined' && definedQty__metafield ) {
  definedMinQty = definedQty__metafield;
}
let keyUpTimeOut = null;
$(function(){
  const params = new URLSearchParams(window.location.search);
  let grt_query_param = params.get("ordertype") || "";
  if(grt_query_param != ""){
    designtype = 1;
    ordername = params.get("order_name") || "";
    if(ordername != ""){
      grt_photo_id = "previously on order # " + ordername;
    }
  }
})
const filePreview = $( `file-preview` );

const apiURL_ = `https://hpz51rjda5.execute-api.us-east-1.amazonaws.com/production`;
const ninjaImgixHost = `ninjauploads-production.imgix.net`;
const ninjaS3Host2 = `ninja-services-production-ninjauploadss3bucket-zks2mguobhe4.s3.amazonaws.com`;
const ninjaS3Host = `ninjauploads-production.imgix.net`;

const uploadArea = document.querySelector('#uploadArea')

// Select Drop-Zoon Area
const dropZoon = document.querySelector('#dropZoon');

// Loading Text
const loadingText = document.querySelector('#loadingText');

// Slect File Input
const fileInput = document.querySelector('#fileInput');

// Select Preview Image
const previewImage = document.querySelector('#previewImage');

// File-Details Area
const fileDetails = document.querySelector('#fileDetails');

// Uploaded File
const uploadedFile = document.querySelector('#uploadedFile');

// Uploaded File Info
const uploadedFileInfo = document.querySelector('#uploadedFileInfo');

// Uploaded File  Name
const uploadedFileName = document.querySelector('.uploaded-file__name');

// Uploaded File Icon
const uploadedFileIconText = document.querySelector('.uploaded-file__icon-text');

// Uploaded File Counter
const uploadedFileCounter = document.querySelector('.uploaded-file__counter');

// ToolTip Data
const toolTipData = document.querySelector('.upload-area__tooltip-data')??"";

let isGangPage = false;
let isDTFPage = true;
if(document.body.classList.contains("template-product-dtf-gang-sheet") || document.body.classList.contains("template-product-uv-gang-sheet"))
  isGangPage = true;

if(document.body.classList.contains("is-dtf-page"))
  isDTFPage = true;

var imagesTypes = ["image/png","image/jpg","image/jpeg","image/tiff","application/pdf","image/vnd.adobe.photoshop","application/postscript","application/vnd.adobe.photoshop","application/x-photoshop","application/photoshop","image/svg+xml"];

// Images Types
if ( isGangPage ) {
  imagesTypes = ["image/png","application/pdf","application/postscript"];
}
var toast = document.querySelector(".toast");
const closeIcon = document.querySelector(".toast .close");
const progress = document.querySelector(".toast .progress");

let timer1, timer2;

function getImageDimensions(url, callback) {
  const img = new Image();
  img.onload = function() {
    const dimensions = {
        width: img.width,
        height: img.height
    };
    callback(dimensions);
  };
  img.onerror = function() {
    callback(null, 'Failed to load image.');
  };
  img.src = url;
}

$( document )
.on(`keyup`, `[name="properties[_Design Notes]"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const designNote            =   $( this ).val();
    const isDesignNoteAvailable =   $( `product-form.product-form form textarea[name="properties[_Design Notes]"]` ).length;
    if ( isDesignNoteAvailable > 0 ) {
      $( `product-form.product-form form textarea[name="properties[_Design Notes]"]` ).val( designNote );
    } else {
      $( `product-form.product-form form` )
        .append( `
          <textarea name="properties[_Design Notes]" style="display: none;">${ designNote }</textarea>
        ` );
    }
  } catch ( err ) {
    console.log( `ERROR [name="properties[_Design Notes]"]`, err.message );
  }
})
;

function resetAll() {
  try {
    selectedItemNo = 1;
    isReadyToPress = false;
    isAIImage = false;
    isAIEdit = false;
    $( `sidebar-drawer#site-cart-sidebar .sidebar__header .sidebar__close` ).click();
    if ( typeof isPuffProduct !== 'undefined' && isPuffProduct ) {
      $( `.popularSizes_puff option` ).removeAttr( `selected` );
      // const getFirstOptionVal = $( `.popularSizes_puff option` ).first().attr( `value` );
      // $( `.popularSizes_puff` ).val( getFirstOptionVal );

      $( `sizes-blocks .widthHeight__custom.puffPage .widthHeight__dropdown` )
        .attr( `selected-color`, `` )
        .removeClass( `noColorSelected` )
        .find( `.widthHeight__dropdown-content span` )
        .removeClass( `selected` );
      // $( '.widthHeight__dropdown-content span' ).first().click();
    }

    if ( typeof enableOption1 !== 'undefined' && enableOption1 || typeof enableOption2 !== 'undefined' && enableOption2 || typeof enableOption3 !== 'undefined' && enableOption3 || typeof enableOption4 !== 'undefined' && enableOption4 ) {
      $( `.customStickerOption[item] .customStickerOption__optionInput` ).prop('checked', false);
      $( `.customStickerOption[item] .customStickerOption__input` ).val( `` );
    }
    updateCartItemCount();

    if ( typeof anotherTransfer !== 'undefined' && anotherTransfer ) {
      const isCustomItemEleAvailable = $( `sizes-blocks .widthHeight__custom[option-selected="custom"]` ).length;
      if ( isCustomItemEleAvailable == 0 ) {
        $( `sizes-blocks .widthHeight__custom[item]` ).remove();
        $( `sizes-blocks .widthHeight__customHeader` ).after( customItemHTML );
      }
    }
    $( `#designer_notes` ).prop( `checked`, false );

  } catch ( err ) {
    console.log( `ERROR resetAll`, err.message );
  }
}
function updateCartItemCount() {
  try {
    $.get(`/cart?view=cartItemsCount`, function ( res ) {
      $( `.header-container .area--cart` ).html( res );
    });
  } catch ( err ) {
    console.log( `ERROR updateCartItemCount()`, err.message );
  }
}

function getCumulativeQty(cartQty, pageQty, max) {
  let cartState =  cartQty + pageQty;
  let x = max - cartState;
  if ( pageQty === 1 ) return (max + 2) - cartState;
  if(x === 0 ) return 1;
  x = max - cartState;
  return x + 1
}

function checkQtyValidation2(this_) {
  try {
    let typingTimer;
    let myTimeout;
    const typingDelay = 700;
    clearTimeout(typingTimer);
    clearTimeout(myTimeout);

    typingTimer = setTimeout(function () {
      let qtyCart = $( this_ ).val() * 1;
      let minCart = $( this_ ).attr( `min` ) * 1;

      if (qtyCart == minCart){
      } else if ( qtyCart < minCart ) {
        //console.log("0")
        $( this_ ).closest( `product-quantity` ).addClass( `error` );
        $( this_ ).closest( `.customQtyFile__wrapper` ).addClass( `error` );
        $( this_ ).css( `color`, `#d00` );
        $( this_ ).val(minCart);
        myTimeout =  setTimeout(() => {
          $( this_ ).closest( `product-quantity` ).removeClass( `error` );
          $( this_ ).closest( `.customQtyFile__wrapper` ).removeClass( `error` );
          $( this_ ).css( `color`, `#000` );
        }, 1500);

      }
      $(".qtyselector.qty-selector").val($(".customQtyFile__qty").val());
      $(".qtyselector.qty-selector").trigger("keyup");
      changeDiscounts();
    }, typingDelay);
  } catch ( err ) {
    console.log( `ERROR checkQtyValidation2`, err.message );
  }
}

function setWidthHeightProperties2() {
  try {
    $( `.customVariantWidget__formProperties` ).remove();

    const heightVal = $(`input[name="height__value"]`).val() * 1;
    const widthVal = $(`input[name="width__value"]`).val() * 1;

    var underscore_val = "";
    if($("body").hasClass("template-product-tackle-twill")  || document.body.classList.contains("template-product-custom-magnets")){
      underscore_val = "_";
    }

    $( `.product-form > form:not(.freeproduct)` ).prepend( `
      <div class="customVariantWidget__formProperties hidden">
        <input type="text" name="properties[${underscore_val}Width (in)]" value="${ widthVal }" class="widthInputEle">
        <input type="text" name="properties[${underscore_val}Height (in)]" value="${ heightVal }" class="heightInputEle">
      </div>
    ` );
  } catch ( err ) {
    console.log( `ERROR setWidthHeightProperties()`, err.message );
  }
}

function patchSize2() {
  const getWidth = $(`input[name="width__value"]`).val() * 1;
  const getHeight = $(`input[name="height__value"]`).val() * 1;
  return ( ( getWidth + getHeight ) / 2 ).toFixed( 2 );
}
function patchSize_sticker() {
  const getWidth = $(`input[name="width__value"]`).val() * 1;
  const getHeight = $(`input[name="height__value"]`).val() * 1;
  //aspectRatio = getWidth / getHeight;
  return ((getWidth * getHeight )).toFixed(2);
}
function selectNearestVariant_sticker() {
  try {
    setTimeout(function() {
      let getPatchSize = patchSize_sticker();
      getPatchSize = getPatchSize * 1;
      var _currentVrntObj = findClosestTotal(allCustomVariants, getPatchSize);
      console.log("in sticker",_currentVrntObj," :_currentVrntObj, getPatchSize: ",getPatchSize);
      customTabelManage(_currentVrntObj.id);
      //$(".selected_sticker").text(_currentVrntObj.title);
      console.log("product-form.product-form [name=id]",$("product-form.product-form input[name=id]"))
      if($("product-form.product-form input[name=id]").length){
        $("product-form.product-form input[name=id]").val(_currentVrntObj.id);
      }else{
        $("product-form.product-form form").append("<input type='hidden' name='id' value='" + _currentVrntObj.id + "' />");//.val();
      }
          setWidthHeightProperties2();
      },4500)
    } catch ( err ) {
      console.log( `ERROR selectNearestVariant()`, err.message );
    }
  }

  let widthHeightDebounceTimer = null;

$(document).on(
  "keyup",
  'input[name="width__value"], input[name="height__value"]',
  function () {
    clearTimeout(widthHeightDebounceTimer);

    widthHeightDebounceTimer = setTimeout(function () {
      console.log("✅ width/height typing finished");
      selectNearestVariant2();
    }, 400); // waits until user stops typing
  }
);

$(document).on(
  "click",
  ".customQtyFile__wrapper__minus, .customQtyFile__wrapper__plus",
  function () {
    clearTimeout(widthHeightDebounceTimer);

    widthHeightDebounceTimer = setTimeout(function () {
      console.log("✅ plus/minus finished");
      selectNearestVariant2();
    }, 200);
  }
);


function selectNearestVariant2() {
  try {
    console.log("in sticker selectNearestVariant2")
    if(document.body.classList.contains("template-product-tackle-twill") || document.body.classList.contains("template-product-custom-magnets")){

    } else {
      console.log("in sticker selectNearestVariant2 2")
      $( `.outputPatch` ).val("");
      setTimeout(function() {
        let getPatchSize = patchSize2();
        getPatchSize = getPatchSize * 1;
        console.log ( 'getPatchSize 222', getPatchSize );
        // $( `.outputPatch` ).val( `${ getPatchSize }"` );

        let heightVal = $(`input[name="height__value"]`).val();
        let widthVal = $(`input[name="width__value"]`).val();

        // if ( heightVal == "" ) {

        const isVariantAvailable = $( `.single-option-selector[data-option="option1"] > div > input[type="radio"][value='${ getPatchSize }"']` ).length;

        if ( isVariantAvailable > 0 ) {
          console.log ( 'c 1',  );
          $( `.single-option-selector[data-option="option1"] > div > input[type="radio"][value='${ getPatchSize }"'] + label.bcpo-front-button-label` ).click();
        } else {
          let nearestID = '';
          $( `.single-option-selector[data-option="option1"] > div > input.bcpo-front-button-option[type="radio"]` ).each(function() {
            let elVal = $( this ).val();
            elVal = parseFloat( elVal );
            console.log ( 'c 22223', elVal );
            if ( getPatchSize < elVal ) {
              nearestID = $( this ).attr( `id` );
              return false;
            }
          })
          if ( nearestID != '' ) {
            console.log ( 'c 2',  );
            $( `.single-option-selector[data-option="option1"] > div > input.bcpo-front-button-option[type="radio"]#${ nearestID } + label.bcpo-front-button-label` ).click();
          } else {
            console.log ( 'c 3',  );
            $( `.single-option-selector[data-option="option1"] > div` ).last().find( `.bcpo-front-button-option` ).click();
          }

          console.log ( 'not matched varaint', nearestID );
        }

        $( `.outputPatch` ).val($(`.single-option-selector[data-option="option1"] > div > input[type="radio"]:checked`).val());
        if(PRODUCT_TEMPLATE.indexOf("-sticker") == -1)
          setWidthHeightProperties2();

          let interValValue = setInterval(function(){
            if($(".outputPatch").val() == ""){
              selectNearestVariant2();
              if(PRODUCT_TEMPLATE.indexOf("-sticker") == -1)
                setWidthHeightProperties2();
            }else{
              clearInterval(interValValue);
            }
          }, 1000)
      }, 2800);
    }

  } catch ( err ) {
    console.log( `ERROR selectNearestVariant()`, err.message );
  }
}
var timeout__;

function changeDiscounts(_keyup = 3500) {
  if(PRODUCT_TEMPLATE.indexOf("tackle-twill") > -1){
    _keyup = 500;
    $(".customVariantWidget__formProperties input").prop("disabled", true);
  }
  setTimeout(function(){
    let selectedVariant = $(`product-form.product-form form [name="id"]`).val();
    let orgPrice = ALL_VARIANTS[selectedVariant].money_without_currency;
    // console.log("orgPrice",orgPrice,selectedVariant);
    let qty = $("precut-unit-logic .customQtyFile__qty").val();
    var discount = Number($(".split_design .customTabelPlace__item:first-child discount").html()).toFixed(2);
    var discount_percentage = Number($(".customTabelPlace__item:first-child").attr("off"));
    if($(".split_design .customTabelPlace__item.selected").length){
      discount = Number($(".split_design .customTabelPlace__item.selected discount").html()).toFixed(2);
      discount_percentage = Number($(".customTabelPlace__item.selected").attr("off"));
    }
    // console.log ( 'triggered', "triggered", qty );

    $("precut-unit-logic .precut-unit-logic__price .__originalPrice").html("$"+orgPrice);
    $("precut-unit-logic .precut-unit-logic__price .__discountedPrice").html("$"+discount+"<span>ea.</span>");
    $("precut-unit-logic .precut-unit-logic__total .__originalPrice").html("$"+(orgPrice * qty).toFixed(2));
    $("precut-unit-logic .precut-unit-logic__total .__discountedPrice").html("$"+(discount * qty).toFixed(2));
    $("precut-unit-logic .precut-unit-logic__discount span").html(discount_percentage+"% off");
    if(discount_percentage == 0 ){
      $("precut-unit-logic .precut-unit-logic__price .__originalPrice,precut-unit-logic .precut-unit-logic__total .__originalPrice,precut-unit-logic .precut-unit-logic__discount span").css({"opacity":0});
    }else{
      $("precut-unit-logic .precut-unit-logic__price .__originalPrice,precut-unit-logic .precut-unit-logic__total .__originalPrice,precut-unit-logic .precut-unit-logic__discount span").css({"opacity":1});
    }
    let w = $(`input[name="width__value"]`).val();
    let h = $(`input[name="height__value"]`).val();
    $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, w );
    $( `file-preview .verticle_direction` ).attr( `y-is`, h );
  },_keyup)

  if(PRODUCT_TEMPLATE.indexOf("tackle-twill") > -1 || PRODUCT_TEMPLATE.indexOf("rhinestone") > -1 ){
    // console.log("hi tackle-twill")
    $(".disabled-cta").addClass("active");
    $(".disabled-cta .add-to-cart,.disabled-cta").removeClass("disabled");

    if(PRODUCT_TEMPLATE.indexOf("rhinestone") > -1){
      setTimeout(function(){
        $('stones-options [op="1"] input').prop("checked",true);
      },1000);
    }
  }
}

if(PRODUCT_TEMPLATE.indexOf("-sticker") > -1 || PRODUCT_TEMPLATE.indexOf("tackle-twill") > -1 || PRODUCT_TEMPLATE.indexOf("custom-magnets") > -1  ){
  changeDiscounts();
  if(PRODUCT_TEMPLATE.indexOf("tackle-twill") > -1  ){
    let time_temp = setTimeout(function(){
      $("precut-unit-logic .customQtyFile__qty").keyup();
      clearInterval(time_temp);
    },550)
  }
}
console.log("PRODUCT_TEMPLATE",PRODUCT_TEMPLATE);
$( document ) 
  .on(`click`, `.widthHeight__item__action-plus`, function( e ) {
    e.stopImmediatePropagation();
     const main = $( this ).closest( `.widthHeight__item__action` );
     let qty     =   main.find( `.widthHeight__value` ).val() * 1;
      qty = qty + 0.25;
    main.find( `.widthHeight__value` ).val( (qty).toFixed(2) ).trigger("keyup");
    if(PRODUCT_TEMPLATE == "stickers" || PRODUCT_TEMPLATE == "custom-magnets")
      selectNearestVariant_sticker();
    else
      selectNearestVariant2();
  })
.on(`click`, `.widthHeight__item__action-minus`, function( e ) {
    e.stopImmediatePropagation();
     const main = $( this ).closest( `.widthHeight__item__action` );
     let qty     =   main.find( `.widthHeight__value` ).val() * 1;
       qty = qty - 0.25;
    main.find( `.widthHeight__value` ).val( (qty).toFixed(2) ).trigger("keyup");
  if(PRODUCT_TEMPLATE == "stickers"  || PRODUCT_TEMPLATE == "custom-magnets" )
      selectNearestVariant_sticker();
    else
      selectNearestVariant2();
})
.on(`click`, `.customQtyFile__wrapper__plus`, function( e ) {
    e.stopImmediatePropagation();
     const main = $( this ).closest( `.customQtyFile__wrapper` );
     let qty     =   main.find( `.customQtyFile__qty` ).val() * 1;
     qty = qty + 0.25;
    main.find( `.customQtyFile__qty` ).val( (qty).toFixed(2) ).trigger("keyup");
 if(PRODUCT_TEMPLATE == "stickers"  || PRODUCT_TEMPLATE == "custom-magnets" )
      selectNearestVariant_sticker();
    else
      selectNearestVariant2();
  })
.on(`click`, `.customQtyFile__wrapper__minus`, function( e ) {
    e.stopImmediatePropagation();
     const main = $( this ).closest( `.customQtyFile__wrapper` );
     let qty     =   main.find( `.customQtyFile__qty` ).val() * 1;
  if ( qty > 0.25 ) {
      qty = qty - 0.25;
  }
    main.find( `.customQtyFile__qty` ).val( (qty).toFixed(2) ).trigger("keyup");
  if(PRODUCT_TEMPLATE == "stickers"  || PRODUCT_TEMPLATE == "custom-magnets")
      selectNearestVariant_sticker();
    else
      selectNearestVariant2();
}).on(`click`, `.customTabelPlace__itemWrapViewAll`, function( e ) {
    e.stopImmediatePropagation();
      $(this).remove();
      $(".customTabelPlace__item").removeClass("barSelected");
  setSelectedRow(Number($(".customTabelPlace__item.selected").attr("index")));
})
.on(`keyup change`, `input[name="width__value"], input[name="height__value"]`,function( e ) {
      let w = $(`input[name="width__value"]`).val();
      let h = $(`input[name="height__value"]`).val();  
     // $("width-ele .inputEle").val(w);
    //  $("height-ele .inputEle").val(h);
    //  $("width-ele .inputEle").trigger("keyup");
  let val = parseFloat($(this).val());
  let _this = $(this);
  setTimeout(function(){
    // _this.val(val.toFixed(2));
  },500);
  
    if(PRODUCT_TEMPLATE == "stickers"  || PRODUCT_TEMPLATE == "custom-magnets")
      selectNearestVariant_sticker();
    else
      selectNearestVariant2();

   changeDiscounts();
  
   let errorInterval =  setInterval(function() {
       // $( `.widthHeight__item__action .widthHeight__value` ).removeClass( `error` );
      },1500);
  
}).on(`keyup`, `.customQtyFile__qty`,function( e ) {
   //   $(".qtyselector.qty-selector").val($(".customQtyFile__qty").val());
   //    $(".qtyselector.qty-selector").trigger("keyup");
    //setTimeout(function(){
   //   changeDiscounts();
   //  console.log ( 'triggered222', "triggered" );
    // },500);
  })
.on(`click change`,`.bcpo-front-button-option, [data-option="option2"] .bcpo-front-image-option, [data-option="option3"] .bcpo-front-image-option`, function( e ) { 
 // setTimeout(() => {
      changeDiscounts(0); // faster refresh
    //}, 100);

   if(PRODUCT_TEMPLATE.indexOf("tackle-twill") > -1 || PRODUCT_TEMPLATE.indexOf("custom-magnets") > -1 ){
    let time_temp = setTimeout(function(){
          $("precut-unit-logic .customQtyFile__qty").keyup();
         clearInterval(time_temp);
    },300)     
   } 
})  
.on(`keyup change`, `input[name="width__value"], input[name="height__value"]`,async function( e ) {
  try {
    e.stopImmediatePropagation();
       $(".call_error_messaage").css({"display":"none"});
    $( `.addToCartGroupItems, .custom_tabs .tab_header` ).addClass( `disabled` );
    clearTimeout( timeout__ );
    timeout__ = setTimeout(() => {
      // console.clear();
      const isSizesBlock = $( `sizes-blocks` ).length;
      if ( isSizesBlock > 0 ) {
        let dpiErr = false;
        const item = $( this ).closest( `.widthHeight__custom[item]` );
        selectedItemNo = item.attr( `item` );

        const selectedOption__ = item.attr( `option-selected` );
        let getVal = $( this ).val() * 1;
        console.log ( 'getVal', getVal );
        let otherVal = 0;
        let by = $( this ).closest( `.widthHeight__item__action` ).attr( `by` );

        const getWidthEle = document.querySelector( `.widthHeight__custom[item="${selectedItemNo}"] .widthHeight__item[by="width"] .widthHeight__value` );
        const getHeightEle = document.querySelector( `.widthHeight__custom[item="${selectedItemNo}"] .widthHeight__item[by="height"] .widthHeight__value` );

        if (
          getWidthEle &&
          isNaN(getWidthEle.value) &&
          getHeightEle &&
          !isNaN(getHeightEle.value)
        ) {
          getHeightEle.dispatchEvent(new Event("keyup"));
          return false;

        } else if (
          getHeightEle &&
          isNaN(getHeightEle.value) &&
          getWidthEle &&
          !isNaN(getWidthEle.value)
        ) {
          getWidthEle.dispatchEvent(new Event("keyup"));
          return false;
        }


        if ( by == 'width' ) {
          otherVal = $( this ).closest( `.widthHeight__custom` ).find( `.widthHeight__item[by="height"] .widthHeight__value` ).val() * 1;
          // if ( typeof getWidthEle !== 'undefined' && getWidthEle.includes( `value="NaN"` ) ) {
          //   getWidthEle.setAttribute( `value`, getVal );
          // }
          // if ( typeof getHeightEle !== 'undefined' && getHeightEle.includes( `value="NaN"` ) ) {
          //   getHeightEle.setAttribute( `value`, otherVal );
          // }
        } else if ( by == 'height' ) {
          otherVal = $( this ).closest( `.widthHeight__custom` ).find( `.widthHeight__item[by="width"] .widthHeight__value` ).val() * 1;
          // if ( typeof getWidthEle !== 'undefined' && getWidthEle.includes( `value="NaN"` ) ) {
          //   getWidthEle.setAttribute( `value`, getVal );
          // }
          // if ( typeof getHeightEle !== 'undefined' && getHeightEle.includes( `value="NaN"` ) ) {
          //   getHeightEle.setAttribute( `value`, otherVal );
          // }
        }

          let isWarningErrorActive = item.find( `dpi-warning` ).hasClass( `active` );

          if ( getVal < userDefinedMinWidth ) {
            console.log ( 'this con 11111',  );

                  // 1. Fix the typed field
                  $(this)
                    .val(userDefinedMinWidth)
                    .attr('value', userDefinedMinWidth)
                    .addClass('minError');

                  // 2. Fix the other dimension ONLY if calculated < min
                  if (by === 'width') {
                      const other = item.find(`.widthHeight__item__action[by="height"] .widthHeight__value`);
                      if ((other.val() * 1) < userDefinedMinWidth) {
                          other.val(userDefinedMinWidth)
                              .attr('value', userDefinedMinWidth)
                              .addClass('minError');
                      }
                  } else {
                      const other = item.find(`.widthHeight__item__action[by="width"] .widthHeight__value`);
                      if ((other.val() * 1) < userDefinedMinWidth) {
                          other.val(userDefinedMinWidth)
                              .attr('value', userDefinedMinWidth)
                              .addClass('minError');
                      }
                  }

                  // 3. Remove dpi warning
                  if (isWarningErrorActive) {
                      item.find(`dpi-warning`).removeClass('active');
                      dpiErr = true;
                  }
                   setTimeout(() => {
                  item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `minError` );
                  item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `maxError` );
                  item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `error` );
                    $( `.widthHeight__item` ).removeClass( `error` );  
                }, 1500);

                  // 4. Recalculate DPI
                  calculateDPILineItem(selectedOption__);

                  // 5. Re-enable UI
                  $( `.addToCartGroupItems, .custom_tabs .tab_header` ).removeClass( `disabled` );

                  // 6. IMPORTANT: STOP EVERYTHING
                  return false;   // <----- STOP ALL RATIO LOGIC
              } else if (getVal > userDefinedMaxHeight) {
                console.log ( 'this con 22222222',  );
                $(".call_error_messaage").css({ display: "flex" });
                $(this)
                  .val(userDefinedMaxHeight)
                  .attr('value', userDefinedMaxHeight)
                  .addClass('maxError');
                getVal = userDefinedMaxHeight;
                if (isWarningErrorActive) {
                  item.find(`dpi-warning`).removeClass('active');
                  dpiErr = true;
                }
              }

        let largerDefinedVal;
        if ( userDefinedMaxLength == userDefinedMaxHeight ) {
          largerDefinedVal = userDefinedMaxLength;
        } else if ( userDefinedMaxLength > userDefinedMaxHeight ) {
          largerDefinedVal = userDefinedMaxLength;
        } else if ( userDefinedMaxHeight > userDefinedMaxLength ) {
          largerDefinedVal = userDefinedMaxHeight;
        }
        if ( getVal == otherVal && getVal > userDefinedMaxLength ) {
          console.log ( 'this condition true',  );
        }
        console.log ( 'bybyby', by );
        if ( by == 'width' && getVal > userDefinedMaxLength ) {
          $( this ).val( userDefinedMaxLength ).addClass( `error` );
          getVal = userDefinedMaxLength;
          if ( isWarningErrorActive ) {
            item.find( `dpi-warning` ).removeClass( `active` );
            dpiErr = true;
          }
        } else if ( by == 'height' && getVal > userDefinedMaxHeight ) {
          $( this ).val( userDefinedMaxHeight ).addClass( `error` );
          getVal = userDefinedMaxHeight;
          if ( isWarningErrorActive ) {
            item.find( `dpi-warning` ).removeClass( `active` );
            dpiErr = true;
          }
        }

        console.log ( 'otherVal', otherVal, size={width: file_width, height: file_height} );
        const getRatio = getNewRatio( `#fileupload_hero`, by, size={width: file_width, height: file_height} );
        const newVal = calculateNewWidth_orNewHeight( getRatio, by, getVal );
        console.log ( 'getRatio', getRatio );
        console.log ( 'by', by );
        console.log ( 'getVal', getVal );
        console.log ( 'newVal', newVal );
        // IN CASE OF EMPTY WIDTH OR HEIGHT
        const recheckWidth = $( `.widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__item[by="width"] .widthHeight__value` ).val();
        const recheckHeight = $( `.widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__item[by="height"] .widthHeight__value` ).val();
        if (Number.isNaN( recheckWidth )) {
          console.log ( 'ITS NOT A NUMBER', recheckWidth );
        }
        if (Number.isNaN( recheckHeight )) {
          console.log ( 'ITS NOT A NUMBER', recheckHeight );
        }

        $( `.widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__item[by="width"] .widthHeight__value` ).val( recheckWidth );
        $( `.widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__item[by="height"] .widthHeight__value` ).val( recheckHeight );

        console.log ( 'recheckWidth', recheckWidth );
        console.log ( 'recheckHeight', recheckHeight );


        if ( by == 'height' && newVal > userDefinedMaxLength ) {
          console.log ( 'connnnnnnnnnn 1',  );
          item.find( `.widthHeight__item__action[by="width"] .widthHeight__value` ).val( userDefinedMaxLength ).attr( `value`, userDefinedMaxLength ).addClass( `error` );

          const getRatio = getNewRatio( `#fileupload_hero`, 'width' );

          const newVal_ = calculateNewWidth_orNewHeight( getRatio, 'width', userDefinedMaxLength );
          console.log ( 'newVal_ H', newVal_ );
          item.find( `.widthHeight__item__action[by="${ by }"] .widthHeight__value` ).val( newVal_.toFixed( 2 ) ).attr( `value`, newVal_.toFixed( 2 ) ).addClass( `error` );

          if ( isWarningErrorActive ) {
            item.find( `dpi-warning` ).removeClass( `active` );
            dpiErr = true;
          }
        } else if ( by == 'width' && newVal > userDefinedMaxHeight ) {
          console.log ( 'connnnnnnnnnn 2',  );
          item.find( `.widthHeight__item__action[by="height"] .widthHeight__value` ).val( userDefinedMaxHeight ).attr( `value`, userDefinedMaxHeight ).addClass( `error` );
          const getRatio = getNewRatio( `#fileupload_hero`, 'height' );
          const newVal_ = calculateNewWidth_orNewHeight( getRatio, 'height', userDefinedMaxHeight );
          console.log ( 'newVal_ W', newVal_ );
          item.find( `.widthHeight__item__action[by="${ by }"] .widthHeight__value` ).val( newVal_.toFixed( 2 ) ).attr( `value`, newVal_.toFixed( 2 ) ).addClass( `error` );

          if ( isWarningErrorActive ) {
            item.find( `dpi-warning` ).removeClass( `active` );
            dpiErr = true;
          }
        } else if ( newVal < userDefinedMinWidth ) {
          console.log ( 'connnnnnnnnnn 3',  );
          if ( by == 'width' ) {
            console.log ( 'connnnnnnnnnn 3.1',  );
            item.find( `.widthHeight__item__action[by="height"] .widthHeight__value` ).val( userDefinedMinWidth ).attr( `value`, userDefinedMinWidth ).addClass( `minError` );

            const getRatio = getNewRatio( `#fileupload_hero`, 'height' );

            const newVal = calculateNewWidth_orNewHeight( getRatio, 'height', userDefinedMinWidth );
            item.find( `.widthHeight__item__action[by="${ by }"] .widthHeight__value` ).val( newVal.toFixed( 2 ) ).attr( `value`, newVal.toFixed( 2 ) ).addClass( `minError` );

            if ( isWarningErrorActive ) {
              item.find( `dpi-warning` ).removeClass( `active` );
              dpiErr = true;
            }
          } else if ( by == 'height' ) {
            console.log ( 'connnnnnnnnnn 3.2',  );
            item.find( `.widthHeight__item__action[by="width"] .widthHeight__value` ).val( userDefinedMinWidth ).attr( `value`, userDefinedMinWidth ).addClass( `minError` );
            const getRatio = getNewRatio( `#fileupload_hero`, 'width' );
            const newVal = calculateNewWidth_orNewHeight( getRatio, 'width', userDefinedMinWidth );
            item.find( `.widthHeight__item__action[by="${ by }"] .widthHeight__value` ).val( newVal.toFixed( 2 ) ).attr( `value`, newVal.toFixed( 2 ) ).addClass( `minError` );

            if ( isWarningErrorActive ) {
              item.find( `dpi-warning` ).removeClass( `active` );
              dpiErr = true;
            }
          }
        } else {
          console.log ( 'connnnnnnnnnn 4',  );
          if ( by == 'width' ) {
            console.log ( 'connnnnnnnnnn 4.1',  );
            item.find( `.widthHeight__item__action[by="height"] .widthHeight__value` ).val( newVal.toFixed( 2 ) ).attr( `value`, newVal.toFixed( 2 ) );
          } else if ( by == 'height' ) {
            console.log ( 'connnnnnnnnnn 4.2',  );
            item.find( `.widthHeight__item__action[by="width"] .widthHeight__value` ).val( newVal.toFixed( 2 ) ).attr( `value`, newVal.toFixed( 2 ) );
          }
        }
        

        setTimeout(() => {
          item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `minError` );
          item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `maxError` );
          item.find( `.widthHeight__item__action .widthHeight__value` ).removeClass( `error` );
          $( `.widthHeight__item` ).removeClass( `error` );   
          if ( dpiErr ) {
            item.find( `dpi-warning` ).addClass( `active` );
            dpiErr = false;
          }
          calculateDPILineItem( selectedOption__ );
        }, 1500);

      
      }
      $( `.addToCartGroupItems, .custom_tabs .tab_header` ).removeClass( `disabled` );
    }, 1000);
  } catch ( err ) {
    console.log( `ERROR input[name="width__value"], input[name="height__value"]`, err.message );
  }
})
;

function calculateDPILineItem(type = "custom") {
  // console.log ( 'type', type );
  if ( typeof fileExt !== 'undefined' && fileExt ) {
    if ( fileExt == 'png' || fileExt == 'jpg' || fileExt == 'jpeg' ) {

      let physicalWidthInInches = $(`sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__value[name="width__value"]`).val();
      let physicalHeightInInches = $(`sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__value[name="height__value"]`).val();
       
      let makeSqInchesForPopular, makeSqInchesForCustom, currentSqInches = 0;
      if ( type == 'popular' ) {
        physicalWidthInInches = Number($( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .popularSizes` ).val().split( ` x ` )[0].replace( '"', '' ).replace( '^', '' ));
        physicalHeightInInches = Number($( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .popularSizes` ).val().split( ` x ` )[1].replace('"','').replace( '^', '' ));

        makeSqInchesForPopular = physicalWidthInInches * physicalHeightInInches;
      } else if ( type == 'custom' ) {
        makeSqInchesForCustom = (uploadedFileWidth * uploadedFileHeight) / 72;
        currentSqInches = ( physicalWidthInInches * physicalHeightInInches ) * 72;
      }

      const pixelWidth = uploadedFileWidth;
      const pixelHeight = uploadedFileHeight;
      // Calculate DPI
      const dpiWidth = pixelWidth / physicalWidthInInches;
      const dpiHeight = pixelHeight / physicalHeightInInches;

      let dpi =  (parseFloat(dpiWidth) + parseFloat(dpiHeight)) / 2;

      if ( type == 'custom' ) {
        if ( makeSqInchesForCustom < 288 ) {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).addClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `Yes` );
        } else if ( makeSqInchesForCustom > 288 && makeSqInchesForCustom > currentSqInches ) {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).removeClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `` );
        } else {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).addClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `Yes` );
        }
      } else if ( type == 'popular' ) {
        const recommendedSqInches = ((uploadedFileWidth / 72) * (uploadedFileHeight / 72));
        // console.log ( 'recommendedSqInches', recommendedSqInches );
        // console.log ( 'makeSqInchesForPopular', makeSqInchesForPopular );
        if ( recommendedSqInches < 4 ) {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).addClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `Yes` );
        } else if ( makeSqInchesForPopular < recommendedSqInches ) {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).removeClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `` );
        } else {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] dpi-warning` ).addClass( `active` );
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"]` ).attr( `dpi-warning`, `Yes` );
        }
      } else {
        // $( `.dpi_warning recommended-size` ).text( `` );
      }
    }
  }
}

function calculateNewWidth_orNewHeight(ratio, by, widthOrHeight) {
  if ( by == 'width' ) {
    const [ratioWidth, ratioHeight] = ratio.split(':').map(Number);
    const newWidth = (widthOrHeight * ratioWidth) / ratioHeight;
    return newWidth;
  } else if ( by == 'height' ) {
    const [ratioHeight, ratioWidth] = ratio.split(':').map(Number);
    const newWHeight = (widthOrHeight * ratioHeight) / ratioWidth;
    return newWHeight;
  }
}

function getRatioFunc(height, width) {
  function gcd(x, y) {
      return y === 0 ? x : gcd(y, x % y);
  }

  const greatestCommonDivisor = gcd(height, width);
  const ratioHeight = height / greatestCommonDivisor;
  const ratioWidth = width / greatestCommonDivisor;

  return `${ratioHeight}:${ratioWidth}`;
}

function getNewRatio( selector, by, size = null ) {
  let getWidth = $( selector ).width() * 1;
  let getHeight = $( selector ).height() * 1;

  if ( size?.width && size?.height ) {
    getWidth = size.width;
    getHeight = size.height;
  }

  let getRatio;
  if ( by == 'height' ) {
    getRatio = getRatioFunc( getWidth, getHeight );
  } else if ( by == 'width' ) {
    getRatio = getRatioFunc( getHeight, getWidth );
  } else {
    getRatio = null;
  }
  return getRatio;
}
 

async function cartItems() {
  try {
    await $.get('/cart?view=ajax', async function ( r ) {
      $( `cart-drawer.drawer` )
        .removeClass( `is-empty` )
        .find( `.drawer__inner` )
        .html( r );
    });
  } catch ( err ) {
    console.log( `ERROR cartItems()`, err.message );
  }
}

async function add2Cart( obj ) {
  try {
    let rtn;
    await $.post(`/cart/add.js`, obj, function ( r ) {
      rtn   =   r;
    },"json");
    return rtn;
  } catch ( err ) {
    console.log( `ERROR add2Cart`, err.message );
  }
}

function calculateRatio( num_1, num_2 ) {
  num_1 = num_1 * 1;
  num_2 = num_2 * 1;

  for(num=num_2; num>1; num--) {
    if((num_1 % num) == 0 && (num_2 % num) == 0) {
      num_1=num_1/num;
      num_2=num_2/num;
    }
  }
  ratio_width   =   num_1 * 1;
  ratio_height  =   num_2 * 1;
}

// ************
async function executeNextStep(imgURL, removebg = true, file_name = false, forcesave = true, s3Key = null, defaultloader = true, file_crc = null, alreadyParamsApplied = '' ) {
  console.log ( 'after toggle url', imgURL );
  const isSizesBlock = $( `sizes-blocks` ).length;
  let isFileFromURL = false;
  if(location.search.indexOf("file=") > -1){
    isFileFromURL = true
  }

  /**
  * Generating Search Query Params
  */
  const queryParamsObject = new URLSearchParams();

  var file_url = imgURL;
  if ( $("#option_checkbox").prop("checked") == false && $("#option_checkbox_upscale").prop("checked") == false ) {
    file_url = imgURL.split("?")[0];
  } else if ( $("#option_checkbox").prop("checked") == true && $("#option_checkbox_upscale").prop("checked") == false ) {
    file_url = imgURL.split("?")[0];
    queryParamsObject.set( 'trim', 'colorUnlessAlpha');
  } else if ( $("#option_checkbox").prop("checked") == false && $("#option_checkbox_upscale").prop("checked") == true ) {
    file_url = imgURL.split("?")[0];
    queryParamsObject.set('bg-remove', true);
  } else if ( $("#option_checkbox").prop("checked") == true && $("#option_checkbox_upscale").prop("checked") == true ) {
    file_url = imgURL.split("?")[0];
    queryParamsObject.set('bg-remove', true);
    queryParamsObject.set('trim', 'colorUnlessAlpha');
  }

  file_url = queryParamsObject.toString().length > 0 ?  `${ file_url }?${ queryParamsObject.toString() }` : file_url;

  if ( isGangPage == true ) {
    file_url = imgURL.split("?")[0].replace(ninjaImgixHost,ninjaS3Host2);
  }

  if ( file_url != '' ) {

    fileExt = file_url.split('.').pop();

    if ( fileExt.includes( `?` ) ) {
      fileExt = fileExt.split( `?` )[0];
    }
    fileExt = fileExt.toLowerCase();

    if(isGangPage == true){
      executeNextStep__helper( 'Y', 'N', defaultloader, file_url, forcesave, file_crc );
      executeNextStep__helper( 'N', 'Y', defaultloader, file_url, forcesave, file_crc );
    } else if ( fileExt == 'psd' || fileExt == 'eps' || fileExt == 'ai' ) {

      let getApiResponse;
      if ( fileExt == 'eps' || fileExt == 'ai' ) {
        getApiResponse  =   await sendApiRequest( `${ file_url }` );
      } else {
        getApiResponse  =   await sendApiRequest( `${ file_url }`, s3Key );
      }
      if ( typeof getApiResponse !== 'undefined' && getApiResponse.success === true ) {
        if ( typeof getApiResponse.data.dimensions !== 'undefined' && getApiResponse.data.dimensions ) {
          if ( fileExt == 'eps' || fileExt == 'ai' ) {
            file_width  =   ( getApiResponse.data.dimensions.width * 4.166666666666667 ) * 300;
            file_height =   ( getApiResponse.data.dimensions.height * 4.166666666666667 ) * 300;
          } else {
            file_width  =   getApiResponse.data.dimensions.width * 300;
            file_height =   getApiResponse.data.dimensions.height * 300;
          }
        }

      } else {
        file_width  =   300;
        file_height =   300;
      }

      $( `.widthHeight__option.customOption .widthHeight__option-detectedSize` ).html( `Detected size: <span d-size>${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"</span>` );
      $(".fileupload_info p").html(`<strong>Cropped size</strong> ${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"`);

      const file__W = ( file_width / 300 ).toFixed(2);
      const file__H = ( file_height / 300 ).toFixed(2);

      executeNextStep__helper( 'Y', 'N', defaultloader, file_url, forcesave, file_crc, file__W, file__H, alreadyParamsApplied );
      executeNextStep__helper( 'N', 'Y', defaultloader, file_url, forcesave, file_crc, file__W, file__H, alreadyParamsApplied );

    } else {
      let getApiResponse;
      let file_url_temp = file_url;
      if ( fileExt == 'pdf' ) {
        file_url_temp = file_url.replace(ninjaS3Host2,ninjaImgixHost).split("?")[0]+"?fm=png";
        let file_url1 = `${ file_url.split("?")[0] }`;
        getApiResponse  =   await sendApiRequest( `${ file_url1 }`, s3Key );
      }

      // getImageDimensions(file_url_temp, {
      //   retries: 1,
      //   retryDelay: 700
      // })
      // .then(dimensions => {
      getImageDimensions(file_url_temp, (dimensions, error) => {
        if (error) {
          console.error(error);
        } else {
          if ( fileExt == 'svg' ) {
            if ( typeof noWidthAndHeightForSVG !== 'undefined' && noWidthAndHeightForSVG ) {
              const getUnitForMultiple = 2480 / dimensions.width;
              file_width = dimensions.width * getUnitForMultiple;
              file_height = dimensions.height * getUnitForMultiple;
              $( `#fileupload_hero` ).addClass( `previewFullWidth` );
            } else {
              file_width = dimensions.width * 4.168067226890756;
              file_height = dimensions.height * 4.168067226890756;
            }
          } else if ( fileExt == 'pdf' && typeof getApiResponse !== 'undefined' && getApiResponse ) {
            if ( getApiResponse.data.dimensions.width > getApiResponse.data.dimensions.height ) {
              let makeMultiplier = getApiResponse.data.dimensions.height / ( dimensions.height / 300 );
              // console.log ( 'makeMultiplier', makeMultiplier );

              file_width = dimensions.width * makeMultiplier;
              file_height = dimensions.height * makeMultiplier;
            } else {
              let makeMultiplier = getApiResponse.data.dimensions.width / ( dimensions.width / 300 );
              // console.log ( 'makeMultiplier', makeMultiplier );

              file_width = dimensions.width * makeMultiplier;
              file_height = dimensions.height * makeMultiplier;
            }
          } else {
            if ( beforeUpScale__Width != 0 && beforeUpScale__height != 0 ) {
              file_width = beforeUpScale__Width;
              file_height = beforeUpScale__height;
              beforeUpScale__Width = 0;
              beforeUpScale__height = 0;
            } else {
              file_width = dimensions.width;
              file_height = dimensions.height;
            }

            // console.clear();
            // console.log ( 'file_width', file_width );
            // console.log ( 'file_height', file_height );

            // if ( file_width == file_height ) {
            //   file_height = file_height - 100;
            // }

            // console.log ( 'file_width', file_width );
            // console.log ( 'file_height', file_height );

            const getTotalPixels = dimensions.width * dimensions.height;
            uploadedFileWidth = dimensions.width;
            uploadedFileHeight = dimensions.height;
            if ( file_width == file_height ) {
              uploadedFileHeight = uploadedFileHeight;
            }
            if ( getTotalPixels > 1000000 && isFileUpload ) {
              // $( `.fileupload_bg_options .style3` ).last().hide();
            }
          }

          $( `.widthHeight__option.customOption .widthHeight__option-detectedSize` )
            .html( `Detected size: <span d-size>${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"</span>` );

          $(".fileupload_info p span").html(`${ (file_width / 300).toFixed(2) }" x ${ (file_height / 300).toFixed(2) }"`);

          if ( isSizesBlock > 0 ) {
            if ( file_width == file_height ) {
              uploadedFileHeight = uploadedFileHeight;
            }
            $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] [name="height__value"]` ).val( `${ (file_height / 300).toFixed(2) }` ).attr( `test`, `${ (file_height / 300).toFixed(2) }` );

            $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] [name="width__value"]` ).val( `${ (file_width / 300).toFixed(2) }` ).attr( `test`, `${ (file_height / 300).toFixed(2) }` );

          } else {
            // $( `.widthHeight__block [name="height__value"]` ).val( `${ (file_height / 300).toFixed(2) }` );

          //   $( `.widthHeight__block [name="width__value"]` ).val( `${ (file_width / 300).toFixed(2) }` );
          }

          $( `.customUploaderWrapper__upload` ).addClass( `hidden` );
          $( `.color-background-1.gradient` ).removeClass( `adjustHeight` );
          $( `.goToNextStep, .underCTA` ).removeClass( `hidden` ).click();

          const file__W = file_width / 300;
          const file__H = file_height / 300;

          executeNextStep__helper( 'Y', 'N', defaultloader, file_url, forcesave, file_crc, file__W, file__H, alreadyParamsApplied );
          executeNextStep__helper( 'N', 'Y', defaultloader, file_url, forcesave, file_crc, file__W, file__H, alreadyParamsApplied);
          // })
          // .catch(err => {
          //   console.error(err);
          // });
        }
      });
    }
  }
  fileInput.value = '';
  if(typeof secondFile != "undefined")
  secondFile.value = '';
  $( `.widthHeight__item` ).removeClass( `error` );
};

function executeNextStep__helper(firstOne='', secondOne='', defaultloader, file_url, forcesave, file_crc, file__W, file__H, alreadyParamsApplied = '' ) {
  try {
    let viewerBoxImg = '';
    if(typeof getfileExt == "undefined")
      getfileExt = file_url.split('.').pop().split("?")[0];
      const isSizesBlock = $( `sizes-blocks` ).length;
      if ( firstOne == 'Y' ) {
        $( `[item-show-on]` )
          .addClass( `hidden` );

        $( `[item-show-on="afterUpload"]` )
          .removeClass( `hidden` );
        let interVal = setInterval(function(){

        let counterNumber = $(".uploaded-file__counter").html().replace("%","") * 1;
        // console.log(".uploaded-file__counter",counterNumber)

        if(counterNumber > 90 ){
          goToNextStep();
          if ( typeof addSlickSlider__ === 'function' && isGangPage == false ) {
            addSlickSlider__();
          }
          if(defaultloader == true)
            // $(".easyzoom").removeClass("image-loading");
            clearInterval(interVal);
        }
      },300);
      setTimeout(() => {
        $(".easyzoom").removeClass("image-loading");
        const isDataSrcAvailable = $(`preview-block .viewer-box img`).attr(`data-src`);
        if ( typeof isDataSrcAvailable !== 'undefined' && isDataSrcAvailable ) {
          $(`preview-block .viewer-box img`).attr(`src`, isDataSrcAvailable);
          // $(`preview-block .viewer-box img`).removeAttr(`data-src`);
        }
       // clearInterval(interVal);
        goToNextStep();
      }, 5000);

      $( `form input[name="properties[Upload]` ).val( file_url );
      //   setTimeout(()=>{
      const fileVal = $( `input[name="properties[Upload]"]` ).length;

      if ( fileVal > 0 ) {
        if ( getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf'  || originalUploadedFileURL.indexOf(".psd") > -1 || originalUploadedFileURL.indexOf(".svg") > -1) {
          $( `product-form.product-form form input[name="properties[Upload]` ).val( originalUploadedFileURL );
        } else {
          $( `product-form.product-form form input[name="properties[Upload]` ).val( file_url );
        }
        if(isGangPage == false)
          $( `product-form.product-form form input[name="properties[_Original Image]` ).val( ( typeof originalUploadedFileURL !== 'undefined' && originalUploadedFileURL ? originalUploadedFileURL : file_url.split("?")[0] ) );
      } else {
        if(isGangPage == true) {
          $( `product-form.product-form form` ).append( `<input type="hidden"  value="${ file_url }" name="properties[Upload]"  />` );
        } else {
          if ( getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf' || originalUploadedFileURL.indexOf(".psd") > -1 ||  originalUploadedFileURL.indexOf(".svg") > -1) {
            $( `product-form.product-form form` )
              .append( `
                <input type="hidden" value="${ originalUploadedFileURL }" name="properties[Upload]" />
                <input type="hidden" value="${ originalUploadedFileURL }" name="properties[_Original Image]" />
              ` );
          } else {
            $( `product-form.product-form form` )
              .append( `
                <input type="hidden" value="${ file_url }" name="properties[Upload]" />
                <input type="hidden" value="${ originalUploadedFileURL }" name="properties[_Original Image]" />
              ` );
          }
        }

        if(grt_photo_id != ""){
          var design_reuse = $( `input[name="properties[design re-used]"]` ).length
          if(design_reuse > 0){
            $( `input[name="properties[design re-used]"]` ).val(grt_photo_id)
          }else{
            $( `product-form.product-form form` ).append( `<input type="hidden" value="${ grt_photo_id }" name="properties[design re-used]" />` );
          }
        }
      }
      // }, 500);
    }

    console.log("secondOne: " + secondOne);
    if ( secondOne == 'Y' ) {
      //  document.querySelector("#fileupload_hero").setAttribute('src', "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/loader-2.gif?v=1723724647");
      // $(".widthHeight__item__action").removeClass("disabled");

      setTimeout(function(){
        if ( isGangPage == true ) {
          $(".viewer-box img").attr('src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }?h=1500`);
          file_url = file_url.replace(ninjaS3Host2,ninjaS3Host)+"?h=1000&auto=compress&q=50";
          document.querySelector("#fileupload_hero").setAttribute('src', file_url);
        } else {
          if ( file_url.includes( `?` ) ) {
            if ( getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf' ) {
              document.querySelector("#fileupload_hero").setAttribute('src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }&fm=png&w=800`);
              $(".viewer-box img").attr('data-src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }&fm=png&w=2000`);
            } else {
              document.querySelector("#fileupload_hero").setAttribute('src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }${alreadyParamsApplied!='' ? `&${alreadyParamsApplied}`:`&fm=png`}`);
              $(".viewer-box img").attr('data-src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }${alreadyParamsApplied!='' ? `&${alreadyParamsApplied}`:`&fm=png`}`);
            }
          } else {
            if ( getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf' ) {
              document.querySelector("#fileupload_hero").setAttribute('src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }?fm=png&w=800`);
              viewerBoxImg = `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }?fm=png&w=2000`;
              $(".viewer-box img").attr('data-src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }?fm=png&w=2000`);
            } else {
              document.querySelector("#fileupload_hero").setAttribute('src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }${alreadyParamsApplied!='' ? `?${alreadyParamsApplied}`:`?fm=png`}`);
              viewerBoxImg = `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }${alreadyParamsApplied!='' ? `?${alreadyParamsApplied}`:`?fm=png`}`;
              $(".viewer-box img").attr('data-src', `${ file_url.replace(ninjaS3Host2,ninjaS3Host) }${alreadyParamsApplied!='' ? `?${alreadyParamsApplied}`:`?fm=png`}`);
            }
          }
        }
      },2000);


      $( `.uploaderFooterNoteSimpleLine` ).addClass( `hidden` );
      console.log("CUSTOMER_ID: " + CUSTOMER_ID + ", forcesave: " + forcesave);
      if(CUSTOMER_ID != null && forcesave == true && file__W && file__H){
        let w = file__W;
        let h = file__H;
        setTimeout(function(){
          $.ajax({
            url: apiURL_+"/uploads/saveData",
            method:"post",
            dataType:"json",
            data: JSON.stringify([{
              "variant_title":  w+"x"+h,
              "file": file_url,
              "customer_id": CUSTOMER_ID,
              "file_name":document.querySelector(".uploaded-file__name").innerHTML,
              "file_crc":file_crc,
              "product_id":PRODUCT_ID,
              "gangsheet": isGangPage
            }])
          });
        },5000)
      }

      // await ApplyDelay( 1000 );
      // showFinalStep();
      const getStep = $( `back-btn` ).attr( `show-step` );

      if ( typeof getStep !== 'undefined' && getStep ) {
        $( `product-form.product-form, .uploaderFooterNote, .designerNote` ).show();
      }
    }
    if(isDTFPage == true){
      let uploadedImage = $('[name="properties[Upload]"]').val();
      if(uploadedImage.indexOf("?") > -1){
       //  uploadedImage = uploadedImage + "&trim=colorUnlessAlpha"
      }else{
       //  uploadedImage = uploadedImage + "?trim=colorUnlessAlpha"
      }
      if(uploadedImage.indexOf(ninjaS3Host2) > -1){
        uploadedImage = $('[name="properties[Upload]"]').val().replace(ninjaS3Host2,ninjaS3Host)+"?bg-remove=true&fm=png";
      }

      
      $(".watermark_image").css({"opacity":1});
      $(".dtf_body_image  .watermark_image img").attr("src",uploadedImage); 
      if($('[href="#custom_size"]').hasClass("active")  == true ){
      //  $(".product-gallery").hide();
     //   $(".dtf_imgix_images").show();
      }
      
    }else{
      if($('[href="#custom_size"]').hasClass("active") == true){
      //  $(".product-gallery").show();
     //   $(".dtf_imgix_images").hide();
      }
    }
     $(".custom_tab_container").removeClass("is_disabled");
    $(`.widthHeight__item__action`).removeClass("disabled");
    setTimeout(function(){
      let w = $(`[name="width__value"]`).val();
      let h = $(`[name="height__value"]`).val()
      $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, w );
      $( `file-preview .verticle_direction` ).attr( `y-is`, h );
      //  $("width-ele .inputEle").val(w);
      //  $("height-ele .inputEle").val(h);
      //   $("width-ele .inputEle").trigger("keyup");

      console.log("file-preview preview-block",w,h)
      $(".disabled-cta").addClass("active");
      $(".cta-wrapper-box").addClass("validated");
    },5000);
    if(($( `.widthHeight__item__action [name="width__value"]` ).val() * 1 ) != 2)
      $( `.widthHeight__item__action [name="width__value"]` ).val( defaultValue );
      $( `.widthHeight__item__action [name="width__value"]` ).trigger("keyup");
    if(PRODUCT_TEMPLATE == "custom-magnets"){
      selectNearestVariant_sticker();
    }else{
      selectNearestVariant2();
    }

    $(".fileupload_bg_options").css({"opacity":1,"pointer-events":"all"});
    setTimeout(() => {
      if ( typeof prodQtyElementClass !== 'undefined' && prodQtyElementClass ) {
        $( `.${ prodQtyElementClass }` ).val( $( `.customQtyFile__qty` ).val() );
      }
      addCartImgProperty();
    }, 8000);

    setTimeout(() => {
   $( `.customQtyFile__qty` ).keyup()
}, 300);

  } catch ( err ) {
    console.log( `ERROR executeNextStep__helper`, err.message );
  }
}

function addCartImgProperty() {
  const getPreviewImgSrc = $(`#fileupload_hero`).attr(`src`);
  const isCartPropertyAvailable = $( `.actualPDPForm [name="properties[_cartImg]"]` ).length;
  if ( typeof isCartPropertyAvailable !== 'undefined' && isCartPropertyAvailable ) {
    $( `.actualPDPForm [name="properties[_cartImg]"]` ).val( getPreviewImgSrc );
  } else {
    $( `.actualPDPForm` ).append( `<input type="hidden" value="${getPreviewImgSrc}" name="properties[_cartImg]" />` );
  }
  const isUploadedFileURLAvailable = $( `input[name="properties[Upload]"]` );
  if ( typeof isUploadedFileURLAvailable !== 'undefined' && isUploadedFileURLAvailable.length > 0 ) {
    let getUPloadVal = isUploadedFileURLAvailable.val();
    if ( typeof getUPloadVal !== 'undefined' && getUPloadVal.includes(`?`) ) {
      getUPloadVal = getUPloadVal.split(`?`)[0];
      $( `input[name="properties[Upload]"]` ).val( getUPloadVal );
    }
  }
  console.log ( 'getPreviewImgSrc', getPreviewImgSrc );
}

function goToNextStep() {
  try { 
    $( `.step__2` ).addClass( `loader` ); 
      setTimeout(() => {
        $( `.step__2` ).removeClass( `hidden` );
      }, 100);
      $( `[item-show-on]` ).addClass( `hidden` );
     $("[data-js-product-price-compact] .product-price").css({"display":"none"});

      $( `[item-show-on="finalStep"], [item-show-on="onAll"]` ).removeClass( `hidden` );
      $( `.step__2` ).removeClass( `loader` );
 
       setTimeout(function(){
          var excludedNames = ["Width (in)", "Height (in)", "Upload", "AI Edit"]; // Array of names to skip
      
          $("[name^=properties]").each(function () {
              var _name = $(this).attr("name");
              var match = _name.match(/^properties\[(.*?)\]$/);
              if (match) {
                  var cleanName = match[1]; 
      
                  if (!excludedNames.includes(cleanName)) {
                      if(_name.indexOf("properties[_") == -1){
                      var newName = _name.replace("properties[", "properties[_"); // Replace properties[ with properties[_
                      $(this).attr("name", newName); // Update the name attribute
                        }
                  }
              }
          });
        },3000)
        
        if( typeof setWidth == "function"){
          setTimeout(function(){
            setWidth();
          })
        }

          setTimeout(function(){
     
  if($(window).outerWidth() > 768){
  
  
      //  console.log($(".bcpo-jumbo-swatches:visible"), ":bcpo-images");
      var style = '<style>';
      var _swatch = $(".bcpo-jumbo-swatches");
      for(var k=0; k < _swatch.length; k++){
        var _title = $.trim($(_swatch).eq(k).parents(".bcpo-images").find(".bcpo-title").text());
        title = $.trim(_title.replace("Select","").replace(":",""));
        //  console.log($.trim(title)," =====title==== ",_title);
        if(title != "Shape--"){
          //  console.log($(_swatch[k]),"_swatch[k]")
          var _imglableList = $(_swatch[k]).find(".bcpo-front-image-label");
          //  console.log(_imglableList,"_imglableList")
          for(var i = 0; i < _imglableList.length; i++){
            // console.log(_imglableList[i],"_imglableList[i]")
            $(_imglableList[i]).addClass("hover-effect hoverindex"+k+i).attr("data-css","hoverindex"+k+i);
            var imageUrl = $(_imglableList[i]).css('background-image').replace(/url\(['"]?(.*?)['"]?\)/, '$1');
            imageUrl = imageUrl.replace(/url\(['"]?(.*?)['"]?\)/, '$1');
            $(_imglableList[i]).attr("data-src",imageUrl);
            $(_imglableList[i]).find('::after').css('background', imageUrl);
            style += '.hoverindex'+k+i+'::after{background:url("' + imageUrl + '");}';
          }
        }
      }
      style += '</style>';
      $(style).appendTo('head');
    

    $(document).on('mousemove', ".hover-effect", function(event) {
      
        $("#tempstyle").remove();
    
        const elemWidth = elemHeight = 250;
        const viewportWidth = $(window).width();
        const viewportHeight = $(window).height();
        const _cssname = $(this).attr("data-css");
    
        // Get the parent element's offset
        const parentOffset = $(this).offset();
        var _top = event.clientY;
    
        // Calculate cursor position relative to the parent element
        let posX = event.pageX - parentOffset.left + 5;
        let posY = event.pageY - parentOffset.top + 5;
    
        // Adjust position based on available space (top or bottom)
        if (posY + elemHeight > viewportHeight) {
            // Not enough space at the bottom, position at the top
            posY = event.pageY - parentOffset.top - elemHeight - 5;
        }
        if (posY < 0) {
            // Not enough space at the top, revert to bottom
            posY = event.pageY - parentOffset.top + 5;
        }
    
        // Adjust position based on available space (left or right)
        if (posX + elemWidth > viewportWidth) {
            // Not enough space on the right, position to the left
            posX = event.pageX - parentOffset.left - elemWidth - 5;
        }
        if (posX < 0) {
            // Not enough space on the left, revert to right
            posX = event.pageX - parentOffset.left + 5;
        }
    
         var sytleVal = ``;
         if((_top + elemWidth) < viewportHeight){
           sytleVal = 'bottom:auto; top:calc(100% + 8px)';
         }
         //console.log((_top + elemWidth) > viewportHeight,sytleVal,posX + elemWidth,viewportHeight,posX);
    
        // Create the dynamic CSS for the ::after element
        const style = `
            <style id="tempstyle">
                div#bcpo.bcpo label.bcpo-front-image-label.hover-effect.${_cssname}:after{ ${sytleVal} } 
            </style>`;
        $(style).appendTo('head');
    });
  } 
        },1000)
  } catch ( err ) {
    console.log( `ERROR .step__1 .goToNextStep`, err.message );
  } 
}

document.querySelector('#fileremove').addEventListener('click', function(e) {
  removeFile(e);
  $(".delivery-block.print-ready-box").removeClass("print-ready-box-hide");
});
function removeFile(e = "") {
  isFileUpload = false;
  isReadyToPress = false;
  if ( typeof isAIImage !== 'undefined' && isAIImage ) {
    $( `.fileupload_bg_options .style3` ).removeClass( `hidden` );
    $( `.fileupload_bg_options .bgRemover` ).remove();
  }
  isAIImage = false;
 // $(".product-gallery").show();
//  $(".dtf_imgix_images").hide();
//  $( `.generative-ai-area` ).removeClass( `hidden` ).show();
//  $(".watermark_image").css({"opacity":0});
  fileInput.value = '';
  $(".custom_tab_container").removeClass("is_disabled");
  $(".widthHeight__item__action").removeClass("disabled");
  $(".easyzoom").removeClass("image-loading");
  $(".upload_image_info").addClass("hidden");
  counter = 0;
  $( `[name="properties[Upload]"]` ).val( '' );
  $( `[name="properties[_Original Image]"]` ).val( '' );
  /* event detail contains the file reference */
  // let file = e.detail;
  $( `.goToNextStep` )
    .addClass( `hidden` );

  $( `[item-show-on]` )
    .addClass( `hidden` );

  $( `[item-show-on="beforeUpload"], [item-show-on="onAll"], .generative-ai-area` )
    .removeClass( `hidden` );
  $( `[item-show-on="beforeUpload"], [item-show-on="onAll"]` )
    .css({"opacity":1});
  $("[data-js-product-price-compact] .product-price").css({"display":"block"});

  $( `.customTabelPlace__item.selected` )
    .removeClass( `selected` );

  /* $( `.customQtyFile__qty` )
    .val( 1 )
    .prop( 1 ); */

  $( `.product` )
    .removeClass( `changeLayout` );

  $( `.step__2` )
    .addClass( `hidden` );

  $( `.fileupload_custom` )
    .hide();

  $( `#aiCreatedImg` ).remove();

  $( `#remove_background, #super_resolution` ).prop( `disabled`, true );

  // Add Class (upload-area--open) On (uploadArea)
  uploadArea.classList.remove('upload-area--open');

  // Hide Loading-text (please-wait) Element
  loadingText.style.display = "none";
  // Show Preview Image
  previewImage.style.display = 'none';

  // Add Class (file-details--open) On (fileDetails)
  fileDetails.classList.remove('file-details--open');
  // Add Class (uploaded-file--open) On (uploadedFile)
  uploadedFile.classList.remove('uploaded-file--open');
  // Add Class (uploaded-file__info--active) On (uploadedFileInfo)
  uploadedFileInfo.classList.remove('uploaded-file__info--active');
  document.querySelector(".drop-zoon__icon").style.display = 'flex';
  document.querySelector(".drop-zoon__paragraph").style.display = 'block';
  //  previewImage.setAttribute('src', "");
  // document.querySelector("#fileupload_hero").setAttribute('src', "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/loader-2.gif?v=1723724647");
  $(".viewer-box img").attr('src', "");
  uploadedFileCounter.innerHTML = `0%`;
  $(".customTabelPopup__overlay-2").fadeOut(500);
  $(".widthHeight__item__action").addClass("disabled");
  $( `.dpi_warning` ).removeClass( `active` );
  //resetAll();
};


async function sendApiRequest(file_url, s3Key ) {
  try {
    if ( s3Key || file_url.indexOf(".pdf") > -1) {
      let rtn;
      let endCode = encodeURI( s3Key );
      if(file_url.indexOf(".pdf") > -1){
        let split_ = file_url.split("/");
         endCode = encodeURI( split_[split_.length - 1]);
      }
        await $.get(`${ apiURL_ + "/calculateInches?s3Key=" + endCode }`, function ( res ) {
        rtn   =   res;
      });
      return rtn;
    }
    else if ( file_url ) {
      let rtn;
      const endCode = encodeURI( file_url );
      await $.get(`${ apiURL_ + "/calculateInches?url=" + endCode }`, function ( res ) {
        rtn   =   res;
      });
      return rtn;
    }
  } catch ( err ) {
    console.log( `ERROR sendApiRequest`, err.message );
  }
}


async function getPresignedUploadUrl(file_name, file_type ) {
  try {
    let rtn;
    await $.get(`${apiURL_}/uploads/getPresignedUploadUrl?file_name=${encodeURIComponent(file_name)}&file_type=${encodeURIComponent(file_type)}`, function ( res ) {
      rtn   =   res;
    });
    return rtn;
  } catch ( err ) {
    console.log( `ERROR getPresignedUploadUrl`, err.message );
  }
}


function selectCurrentImage( o ) {
  try {
    $( `.product__mainImg` )
      .attr( `src`, o.large )
      .fadeIn();

    $( `.product__mainImgWrap iframe` )
      .fadeOut();

    $( `media-gallery .product__thumbItem` )
      .removeClass( `selected` );

    $( `.product__thumbItem.currentVariant` )
      .attr( `img`, o.large )
      .addClass( `selected` )
      .find( `img` )
      .attr( `src`, o.thumb );

  } catch ( err ) {
    console.log( `ERROR selectCurrentImage`, err.message );
  }
}

const getMeta = async (url, cb) => {
  const img   =   new Image();
  img.onload  =   () => cb(null, img);
  img.onerror =   (err) => cb(err);
  img.src     =   url;
};

async function manageSteps( hideStep, showStep ) {
  try {
    const step_1_elements = '.pdp__block.customTitle, .customReviews, .pdp__block.customDescription, .customBadgesPlace, .customBadgesPlace+hr, .customVariants, .customContent, .product-form__input.product-form__quantity, .customTabelPlace, .customPrecut, .customQtyFile, .customTabelPlaceWrap';
    const step_2_elements = '.fileupload_custom';
    const step_3_elements = '.afterUploadAdd2Cart, .customStep2_upload_title, .customStep2_upload_description, .customStep2_upload_list';
    if ( hideStep == 1 ) {
      $( step_1_elements )
        .hide();
    } else if ( hideStep == 2 ) {
      $( step_2_elements )
        .hide();
    } else if ( hideStep == 3 ) {
      $( step_3_elements )
        .hide();
    }

    if ( showStep == 1 ) {
      $( step_1_elements )
        .show();
    } else if ( showStep == 2 ) {
      $( step_2_elements )
        .show();
    } else if ( showStep == 3 ) {
      $( step_3_elements )
        .show();
    }

  } catch ( err ) {
    console.log( `ERROR manageSteps`, err.message );
  }
}

async function setSteps( hideStep, showStep ) {
  try {
    $( `.customStep2_upload back-btn` )
      .attr({
        "show-step": showStep,
        "hide-step": hideStep
      });
    if ( showStep == 1 ) {
      $( `.customStep2_upload back-btn` )
        .removeClass( `makeItHide` );
    } else {
      $( `.customStep2_upload back-btn` )
        .addClass( `makeItHide` );
    }
  } catch ( err ) {
    console.log( `ERROR setSteps`, err.message );
  }
}


function showFinalStep() {
  try {

    // const checkFooterLine = $( `.uploaderStep2FooterBtn` ).length;
    // if ( checkFooterLine == 0 ) {
    //   $( `.shopify-block.shopify-app-block [data-upload-field]` )
    //   .append( `
    //     <div class="uploaderStep2FooterBtn">
    //       Next Step
    //     </div>
    //   ` );
    // }
    // console.log ( 'yes got value' );
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

function checkingFieldVal( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ).value != '' ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingFieldVal`, err.message );
  }
}

function checkingElement( selectorIs, functionName, timer, args='' ) {
  try {
    var divCheckingInterval                   =   setInterval( function() {
      if ( document.querySelector( selectorIs ) ) {
        clearInterval( divCheckingInterval );
        if ( typeof functionName !== 'undefined' && functionName ) {
          window[functionName]( args ? args : '' );
        }
        return true;
      }
    }, timer != '' ? timer : 250);
    return false;
  } catch ( err ) {
    console.log( `ERROR checkingElement`, err.message );
  }
}

async function add2Cart( obj ) {
  try {
    let rtn;
    await $.post(`/cart/add.js`, obj, function ( r ) {
      rtn = r;
    },"json");
    return rtn;
  }
  catch ( err ) {
    console.log( `ERROR add2Cart`, err.message );
  }
}

var ApplyDelay = ms => new Promise(res => setTimeout(res, ms));

function uploaderDataManage() {
  if ( typeof uploadData !== 'undefined' && uploadData ) {
    const isSimpleLineAvailable = $( `.uploaderFooterNoteSimpleLine` ).length;
    if ( isSimpleLineAvailable == 0 ) {
      // $( `.cl-upload--input-field` )
      // .before( `
      //   <div class="uploaderFooterNoteSimpleLine">${ uploadData.beforeFileUpoadNote }</div>
      // ` );
    }
    if ( typeof uploadData.underUploaderNote !== 'undefined' && uploadData.underUploaderNote ) {
      const uploaderStep2FooterBtn    =   $( `.uploaderStep2FooterBtn` ).length;
      const checkFooterLine           =   $( `.uploaderFooterNote` ).length;
      if ( checkFooterLine == 0 ) {
        const getDesignNote           =   $( `[name="properties[_Design Notes]"]` ).val();
        $( `[name="properties[_Design Notes]"]` )
          .prop( 'disabled', true )
          .attr( `type`, `hidden` )
          .before( `
            <div class="uploaderFooterNote">
              ${ uploadData.underUploaderNote }
            </div>
            <textarea class="designerNote" name="properties[_Design Notes]" placeholder="ex. Remove background & make sure design is 3.5\" wide">${ getDesignNote }</textarea>
          ` );
      }
    }
  }

  const selectedQty = $( `.customQtyFile__qty` ).val();
  const isQtyElement = $( `product-form.product-form form[action="/cart/add"] [name="quantity"]` ).length;
  if ( isQtyElement == 0 ) {
    $( `product-form.product-form form[action="/cart/add"]` )
      .append( `
        <input type="hidden" name="quantity" value="${ selectedQty }">
      ` );
  } else {
    $( `product-form.product-form form[action="/cart/add"] [name="quantity"]` ).val( selectedQty );
  }
}

function getData( type ) {
  try {
    const dataArr = [['1 - 9', '0%', 'discount']];
    $( `.quantity-breaks-now-discount-table .qb-discount-table-row` ).each(function(i) {
      let collobj = [];
      $( this ).find( `td` ).each(function() {
        const text = $( this ).text().trim();
        collobj.push( text )
      })

      dataArr.push( collobj );
    })

    let tableHTML = '';
    dataArr.forEach(el => {
      tableHTML +=  `<div class="customTabelPlace__item">`;
        el.forEach((col, i) => {
          tableHTML +=  `<div class="customTabelPlace__item_${ i + 1 }">${ col }</div>`;
        });
      tableHTML +=  `</div>`;
    });

    $(`.customTabelPlace.colList` )
      .attr( `items`, dataArr.length )
      .html( tableHTML )
      .removeClass( `hide` );

    if ( type != 'onLoad' ) {
      const getOp_1 = $( `.product-form__input[op="1"] input:checked` ).val();
      const getOp_2 = $( `.product-form__input[op="2"] input:checked` ).val();

      if ( typeof getOp_1 !== 'undefined' && getOp_1 && typeof getOp_2 !== 'undefined' && getOp_2 && typeof allVariants !== 'undefined' && allVariants && typeof findObjectByKey === 'function' ) {
        const selectedVariant_ob = findObjectByKey( allVariants, 'title', `${ getOp_1 } / ${ getOp_2 }` );
        if ( typeof selectedVariant_ob.id !== 'undefined' && selectedVariant_ob.id ) {
          $( `[name="id"]` ).val( selectedVariant_ob.id );

          $( `.product__mainImg` )
            .attr( `src`, selectedVariant_ob.large )
            .fadeIn();
          $( `.product__mainImgWrap iframe` )
            .fadeOut();
          $( `media-gallery .product__thumbItem` )
            .removeClass( `selected` );
          $( `.product__thumbItem.currentVariant` )
            .attr( `img`, selectedVariant_ob.large )
            .addClass( `selected` )
            .find( `img` )
            .attr( `src`, selectedVariant_ob.thumb );
        }
      }
    }
  } catch ( err ) {
    console.log( `ERROR getData()`, err.message );
  }
}
 
$( document )
.ready(function () {
 
}).on(`click`, `.modalDialog__centerCenter__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `.modalDialog` ).fadeOut();
    const isIframeAvailable = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).length;
    if ( isIframeAvailable > 0 ) {
      const videoSrc = $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` ).attr( `src` );
      $( this ).closest( `.modalDialog` ).find( `.modalDialog__centerCenter__content--detail iframe` )
        .removeAttr( `src` )
        .attr( `src-old`, videoSrc );
    }
  } catch ( err ) {
    console.log( `ERROR .modalDialog__centerCenter__close`, err.message );
  }
})
;
// MODAL EVENTS END

function cartCountUpdate() {
  try {
    $.get(`/cart?view=itemsCount`, function ( res ) {
      $( `#cart-icon-bubble` ).html( res );
    });
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

let field__;
 




const mainDropZone = document.querySelector( "body" );
mainDropZone.addEventListener('dragover', (e) => {
  e.preventDefault();
  // document.querySelector( `.uploaderOverlay` ).classList.add( `active` );
});
mainDropZone.addEventListener('drop', async (e) => {
  // field__.uploadFile( e.dataTransfer.files[0] ).then(function(file) {
  //   secondryDropZone.classList.remove( `active` );
  //   console.debug('got file upload: ', file);
  //   // document.querySelector( `.uploaderOverlay` ).classList.remove( `active` );
  // });

  e.preventDefault()
});
if(document.querySelector( `.secondDropZone` )){
  var secondryDropZone = document.querySelector( `.secondDropZone` );
  secondryDropZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    secondryDropZone.classList.add( `active` );
    document.querySelector(".file-upload-overlay-2").classList.add("active");
    document.querySelector("body").classList.add("file-upload-overlay-2-active");
  });

  secondryDropZone.addEventListener('drop', async (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    anotherTransfer = true;
    if ( typeof isPuffProduct !== 'undefined' && isPuffProduct ) {
      anotherPuff = true;
    }
    uploadFile(file, "second_image");
  });

  secondryDropZone.addEventListener('dragleave', (e) => {
    e.preventDefault();
    secondryDropZone.classList.remove( `active` );
    document.querySelector(".file-upload-overlay-2").classList.remove("active");
    document.querySelector("body").classList.remove("file-upload-overlay-2-active");
  });
}
$( document )
.ready(function () {
  
})
.on(`change`, `#secondFile`, function( e ) {
  e.stopImmediatePropagation();
 
  let optionErr = false;
  
    
  if ( optionErr ) {
    $( this ).val( `` );
    return;
  } 
  anotherTransfer = true;
  
  uploadFile( e.currentTarget.files[0], "second_image");
})
 
.on(`keyup`, `.cart-item__actions ._cart__quantity.qty.qty-selector`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    alreadyCartItemsFunc();
  } catch ( err ) {
    console.log( `ERROR .cart-item__actions ._cart__quantity.qty.qty-selector`, err.message );
  }
});
 
if(location.search.indexOf("file=") > -1) { 
  let datapath = decodeURIComponent(location.search.split("file=")[1]);
  console.log('datapath on load', datapath);

  // --- UI Updates (your existing code) ---
  dropZoon.classList.add('drop-zoon--Uploaded');
  uploadedFile.classList.remove('uploaded-file--open');
  uploadedFileInfo.classList.remove('uploaded-file__info--active');
  uploadArea.classList.add('upload-area--open'); 
  uploadedFileInfo.classList.add('uploaded-file__info--active');
  document.querySelector(".fileupload_custom").style.display = "block";
  progressMove("quick",0);
  document.querySelector("#uploadArea").classList.add("hidden"); 
  $(".easyzoom").addClass("image-loading");

  // --- STEP 1: Fetch file from given URL ---
  async function fetchFileFromUrl(fileUrl) {
    if(datapath.indexOf("ordertype") > -1){
      var fileUrl = datapath.split("&ordertype")[0];
    }
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error("Failed to fetch file from URL");
    const blob = await response.blob();
    const fileName = fileUrl.split("/").pop().split("?")[0]; // keep original file name
    return new File([blob], fileName, { type: blob.type });
  }

  (async function(){
    try {
      const file = await fetchFileFromUrl(datapath);

      // --- Use the existing file name instead of random one ---
      const fileName = file.name;  // e.g. myDesign.png

      // --- STEP 2: Upload to S3 ---
      const presignData = await getPresignedUploadUrl(fileName, file.type);
      if (!presignData.url) throw new Error("No presigned URL");

      await fetch(presignData.url, { method: 'PUT', body: file });

      // --- STEP 3: Build Imgix URL ---
      let filePath = `https://${ninjaImgixHost}/${fileName}`;

      // Update UI image previews
      document.querySelector("#fileupload_hero").setAttribute('src', filePath);
      $(".viewer-box img").attr('src', filePath);

      // --- STEP 4: File extension logic (your original checks) ---
      let getfileExt = fileName.split(".").pop();
      originalUploadedFileURL = filePath; // now use Imgix path

      console.log("getfileExt", getfileExt);

      if(getfileExt == "png" || getfileExt == "svg" || getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf'  || originalUploadedFileURL.indexOf(".psd") > -1  || originalUploadedFileURL.indexOf(".svg") > -1){
        $("#option_checkbox").prop("checked",false);
        $("#remove_background").val("No");
        $("#super_resolution").val("No");
      //  $(".fileupload_bg_options .style3").last().hide();
        $(".option_checkbox, #option_checkbox_upscale").prop("checked", false);
      } else {
        $("#option_checkbox").prop("checked",false);
        $("#remove_background").val("No");
        $("#super_resolution").val("No");
      }
      $("#option_checkbox_upscale").prop("checked",false);
      $(".custom_tab_container").addClass("is_disabled");
      $(".widthHeight__item__action").addClass("disabled");
      $(".fileupload_bg_options").css({"opacity":0.5,"pointer-events":"none"}); 

      // --- STEP 5: CRC optional ---
      let file_crc = "";
      try {
        const byteArr = await getAsByteArray(file);
        file_crc = (CRC32.buf(byteArr)>>>0).toString(16);
      } catch (error) {
        console.log("Unable to calculate file crc: " + error)
      }

      // --- STEP 6: Continue your flow ---
      executeNextStep(filePath, true, true, true, fileName, true, file_crc);

      // --- STEP 7: Hidden inputs for Shopify form ---
      let _originalUploadedFileURL = originalUploadedFileURL.replace(ninjaImgixHost,ninjaS3Host2).split("?")[0];  
      let vector = originalUploadedFileURL.split('/').pop().split("?")[0];
      vector = "https://"+ninjaImgixHost+"/"+vector;
      let org = _originalUploadedFileURL;  
      if ( getfileExt == 'ai' || getfileExt == 'eps' || getfileExt == 'pdf'  || _originalUploadedFileURL.indexOf(".psd") > -1  || _originalUploadedFileURL.indexOf(".svg") > -1) {
        vector = org;
      }

      setTimeout(function() { 
        const checkPropertyEle = $(`product-form.product-form form [name="properties[Upload]"]`).length; 
        if (checkPropertyEle == 0) {
          $(`product-form.product-form form`)
            .append(`
              <input type="hidden" name="properties[Upload]" value="${ vector }">
              <input type="hidden" name="properties[_Original Image]" value="${ org }">
            `);
        } else {
          $(`product-form.product-form form [name="properties[Upload]"]`).val(`${ vector }`);
          $(`product-form.product-form form [name="properties[_Original Image]"]`).val(`${ org }`);
        }
      },6000);

    } catch(err) {
      console.error("Error handling file from URL:", err);
    }
  })();
}




async function alreadyCartItemsFunc() {
  try {
    await ApplyDelay(1000);
    if ( typeof tableDiscountType !== 'undefined' && tableDiscountType == 'cartTotal' ) {
      const getCartTotalObj = await getRequest( `/cart?view=pdpCartObject` );
      if ( typeof getCartTotalObj !== 'undefined' && getCartTotalObj ) {
        getCartTotal = getCartTotalObj.getCartTotal;
        const getTableFirstRowPrice = $( `.customTabelPlaceWrap` ).attr( `base-price` ) * 1;
        let getCalculatedQty = getCartTotal / getTableFirstRowPrice;
        getCalculatedQty__ = Math.floor( getCalculatedQty );
      }
    }

    alreadyCartItems = await getRequest( `/cart?view=pdpCartItem&pid=${ typeof currentPID !== 'undefined' && currentPID ? currentPID : '' }` );
    if (
      typeof alreadyCartItems !== 'undefined' && alreadyCartItems && typeof alreadyCartItems.qty !== 'undefined' && alreadyCartItems.qty > 0 ||
      typeof isSpangleProduct !== 'undefined' && isSpangleProduct && typeof alreadyCartItems !== 'undefined' && alreadyCartItems && typeof alreadyCartItems.spangleQty !== 'undefined' && alreadyCartItems.spangleQty > 0 ||
      typeof isCustomStickerProduct !== 'undefined' && isCustomStickerProduct && typeof alreadyCartItems !== 'undefined' && alreadyCartItems && typeof alreadyCartItems.stickersQty !== 'undefined' && alreadyCartItems.stickersQty > 0 ||
      typeof isBumperStickerProduct !== 'undefined' && isBumperStickerProduct && typeof alreadyCartItems !== 'undefined' && alreadyCartItems && typeof alreadyCartItems.stickersQty !== 'undefined' && alreadyCartItems.stickersQty > 0
    ) {
      if ( typeof tableDiscountType !== 'undefined' && tableDiscountType == 'Cumulative' ) {
        alreadyCartItems = [alreadyCartItems];
      } else if ( typeof tableDiscountType !== 'undefined' && tableDiscountType == 'cartTotal' ) {
        alreadyCartItems = [];
      } else {
        alreadyCartItems = [];
      }
    } else {
      alreadyCartItems = [];
    }
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}




// Append Images Types Array Inisde Tooltip Data
toolTipData.innerHTML = [...imagesTypes].join(', .');

// When (drop-zoon) has (dragover) Event
uploadArea.addEventListener('dragover', function (event) {
  // Prevent Default Behavior
  event.preventDefault();

  // Add Class (drop-zoon--over) On (drop-zoon)
  uploadArea.classList.add('drop-zoon--over');
  document.querySelector(".file-upload-overlay-1").classList.add("active");
  document.querySelector("body").classList.add("file-upload-overlay-1-active");
});

// When (drop-zoon) has (dragleave) Event
uploadArea.addEventListener('dragleave', function (event) {
  // Remove Class (drop-zoon--over) from (drop-zoon)
  uploadArea.classList.remove('drop-zoon--over');
  document.querySelector(".file-upload-overlay-1").classList.remove("active");
  document.querySelector("body").classList.remove("file-upload-overlay-1-active");
});

// When (drop-zoon) has (drop) Event
uploadArea.addEventListener('drop', function (event) {
  // Prevent Default Behavior
  event.preventDefault();

  // Remove Class (drop-zoon--over) from (drop-zoon)
  uploadArea.classList.remove('drop-zoon--over');
  document.querySelector(".file-upload-overlay-1").classList.remove("active");
  document.querySelector("body").classList.remove("file-upload-overlay-1-active");

  // Select The Dropped File
  const file = event.dataTransfer.files[0];

  if (file.type == 'image/svg+xml') {
    const reader = new FileReader();
    reader.onload = function(e) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(e.target.result, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      const width = svgElement.getAttribute('width');
      const height = svgElement.getAttribute('height');
      if ( width == null && height == null ) {
        noWidthAndHeightForSVG = true;
      } else {
        noWidthAndHeightForSVG = false;
      }
      // document.getElementById('output').innerText = `Width: ${width}, Height: ${height}`;
    };
    reader.readAsText(file);
  }

  // Call Function uploadFile(), And Send To Her The Dropped File :)
  uploadFile(file);
});

// When (drop-zoon) has (click) Event
uploadArea.addEventListener('click', function (event) {
  // Click The (fileInput)
  if ( typeof btnTextUpdated !== 'undefined' && btnTextUpdated ) {
    $( `.product__cart-functions .add-to-cart[data-main-product-add-to-cart] .button__text[data-js-product-add-to-cart-text]` ).text( btnTextUpdated );
    KROWN.settings.locales.products_add_to_cart_button = btnTextUpdated;
  }
  fileInput.click();
});

// When (fileInput) has (change) Event
fileInput.addEventListener('change', function (event) {
  // Select The Chosen File
  if ( typeof btnTextUpdated !== 'undefined' && btnTextUpdated ) {
    $( `.product__cart-functions .add-to-cart[data-main-product-add-to-cart] .button__text[data-js-product-add-to-cart-text]` ).text( btnTextUpdated );
    KROWN.settings.locales.products_add_to_cart_button = btnTextUpdated;
  }
  $( `#fileupload_hero` ).addClass( `previewFullWidth` );
  $( `.pricingTable` ).addClass( `hidden` );
  const file = event.target.files[0];
  if (file.type == 'image/svg+xml') {
    const reader = new FileReader();
    reader.onload = function(e) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(e.target.result, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;
      const width = svgElement.getAttribute('width');
      const height = svgElement.getAttribute('height');
      if ( width == null && height == null ) {
        noWidthAndHeightForSVG = true;
        // console.log ( `NO Width and Height` );
      } else {
        noWidthAndHeightForSVG = false;
        // console.log ( '`Width: ${width}, Height: ${height}`', `Width: ${width}, Height: ${height}` );
      }
      // document.getElementById('output').innerText = `Width: ${width}, Height: ${height}`;
    };
    reader.readAsText(file);
  }

  // Call Function uploadFile(), And Send To Her The Chosen File :)
  uploadFile(file);
});

async function getAsByteArray(file) {
  return new Uint8Array(await readFile(file));
}

function readFile(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.addEventListener("loadend", (e) => resolve(e.target.result));
    reader.addEventListener("error", reject);
    reader.readAsArrayBuffer(file);
  });
}

if(location.search == "?rtype=another"){
  toast2( `Added`, `Item added successfully` );
  $('html, body').animate({
    scrollTop: ($("product-variants").offset().top - 80)
  }, 500);
}

function toast2( title, msg, color='green', timer=5000 ) {
  try {
   $( `.toast` ).remove();
  $( `body` ).append( `<div class="toast ${ color }">
  <div class="toast-content">
    <svg class="fas fa-solid fa-check check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/></svg>
    <div class="message">
      <span class="text text-1">${ title }</span>
      <span class="text text-2">${ msg }</span>
    </div>
    </div>
    <svg class="fa-solid fa-xmark close" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18" stroke="#000" stroke-linecap="round"></path><path d="M18 6L6.00001 18" stroke="#000" stroke-linecap="round"></path></svg>
    <div class="progress active"></div></div>` );
    setTimeout(() => {
      $( `.toast` ).addClass( `active` );
    }, 50);
    setTimeout(() => {
      $( `.toast` ).removeClass( `active` );
    }, timer);
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}
// Upload File Function
function uploadFile(file, uploadtype = null) {
  // FileReader()
  isFileUpload = true;
  if($(".delivery-block.print-ready-box").length){
    $(".delivery-block.print-ready-box").addClass("print-ready-box-hide");
  }
  
  // console.log ( 'upload file start',  );
  const isSizesBlock = $( `sizes-blocks` ).length;
  const fileReader = new FileReader();
  // File Type
  const fileType = file.type;
 //alert(fileType);
  // File Size
  const fileSize = file.size;
  $( `.generative-ai-area` ).addClass( `hidden` );
  // If File Is Passed from the (File Validation) Function
  if (fileValidate(fileType, fileSize, file)) {
    if(fileType.indexOf("image/png") > -1 || fileType.indexOf("image/svg+xml")  > -1 || fileType.indexOf("application/") > -1){
     // $("#option_checkbox").prop("checked",false);
     // $("#remove_background").val("No");
    }else{
   //   $("#option_checkbox").prop("checked",true);
   //   $("#remove_background").val("Yes");
    }
    $("#option_checkbox").prop("checked",false);
    $("#option_checkbox_upscale").prop("checked",false);
    $(".custom_tab_container").addClass("is_disabled");
    $(".widthHeight__item__action").addClass("disabled");
    $(".fileupload_bg_options").css({"opacity":0.5,"pointer-events":"none"});
    $(".easyzoom").addClass("image-loading");
    // alert(uploadtype);
    if(uploadtype == "second_image"){
  //    $(".product-gallery").show();
   //   $(".dtf_imgix_images").hide();
   //   $(".watermark_image").css({"opacity":0});
      // alert("inner"+uploadtype);
      if ( $( `.loadingScreen__` ).length == 0 ) {
        $( `body` ).prepend( `<div class="loadingScreen__"><img src="${ loaderGif }"></div>` );
      }
      document.body.classList.add("processing-second-upload");
      secondryDropZone.classList.remove( `active` );
      document.querySelector(".file-upload-overlay-2").classList.remove("active");
      document.querySelector("body").classList.remove("file-upload-overlay-2-active");
      $( `.anotherTransfer` ).click();
       
      $("#fileremove").click();
      $( `[name="properties[_Design Notes]"]` ).val( `` );
      uploadFile(file);
     toast2( `Added`, `Item added successfully` );
    
      setTimeout(function(){
        document.body.classList.remove("processing-second-upload");
        $( `.loadingScreen__` ).remove();
       // $(".precut-unit-logic__qty .customQtyFile__qty").val(100).attr("data-value",100); 
        $("#designer_notes").prop("checked",false);
         $('[name="properties[_Design Notes]"]').val("");
          $('#bcpo [type="radio"]').prop("checked",false);
         $('#bcpo .bcpo-simple.bcpo-text [type="text"]').val("");
        // $(".second-upload-cta").addClass( `disabled` );
        //  $(".second-upload-cta").removeClass( `active` );
      },5000);

      $( `.customQtyFile__qty` ).val(parseInt($( `.customQtyFile__qty` ).attr("min")));
      $("product-form .add-to-cart").addClass("second-tranfer-btn")
      return false;
    }
    // Add Class (drop-zoon--Uploaded) on (drop-zoon)
    dropZoon.classList.add('drop-zoon--Uploaded');

    // Show Loading-text
    loadingText.style.display = "block";
    // Hide Preview Image
    //  previewImage.style.display = 'none';

    // Remove Class (uploaded-file--open) From (uploadedFile)
    uploadedFile.classList.remove('uploaded-file--open');
    // Remove Class (uploaded-file__info--active) from (uploadedFileInfo)
    uploadedFileInfo.classList.remove('uploaded-file__info--active');

    // After File Reader Loaded
    fileReader.addEventListener('load', async function () {
      // After Half Second
      // setTimeout(function () {
      // Add Class (upload-area--open) On (uploadArea)
      uploadArea.classList.add('upload-area--open');

      // Hide Loading-text (please-wait) Element
      loadingText.style.display = "none";
      // Show Preview Image
      //  previewImage.style.display = 'block';

      // Add Class (file-details--open) On (fileDetails)
      fileDetails.classList.add('file-details--open');
      // Add Class (uploaded-file--open) On (uploadedFile)
      uploadedFile.classList.add('uploaded-file--open');
      // Add Class (uploaded-file__info--active) On (uploadedFileInfo)
      uploadedFileInfo.classList.add('uploaded-file__info--active');
      // document.querySelector(".drop-zoon__icon").style.display = 'none';
      // document.querySelector(".drop-zoon__paragraph").style.display = 'none';
      // executeNextStep(filePath, true, true);
      // }, 500); // 0.5s

      // Add The (fileReader) Result Inside (previewImage) Source
      // previewImage.setAttribute('src', fileReader.result);
      if(file.name.indexOf(".pdf") > -1 || file.name.indexOf(".psd") > -1 || file.name.indexOf(".eps") > -1 || file.name.indexOf(".svg") > -1 || file.name.indexOf(".ai") > -1 ) {
        document.querySelector("#fileupload_hero").setAttribute('src', "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/transparent.png?v=1728297951");
      } else {
        if (isGangPage) {
          document.querySelector("#fileupload_hero").setAttribute('src', "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/transparent.png?v=1728297951");
        } else {
          // document.querySelector("#fileupload_hero").setAttribute('src', fileReader.result);
        }
      }
      //document.querySelector("#fileupload_hero").setAttribute('src', "https://cdn.shopify.com/s/files/1/0558/0265/8899/files/loader-2.gif?v=1723724647");

      // Add File Name Inside Uploaded File Name
      uploadedFileName.innerHTML = file.name;
      document.querySelector(".fileupload_custom").style.display = "block";
      progressMove("",fileSize);

      document.querySelector("#uploadArea").classList.add("hidden");
      // Call Function progressMove();
      // Configure AWS SDK with your credentials

      const randomName = file.name.split('.')[0].replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-')+"____"+'image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.' + file.name.split('.').pop();

      getfileExt = randomName.split('.').pop();
      if ( getfileExt == 'psd' || getfileExt == 'eps' || getfileExt == 'ai' || getfileExt == 'pdf'  || getfileExt == 'svg'  ) {
       //  $( `.fileupload_bg_options .style3` ).last().hide();
       // $( `#option_checkbox_upscale` ).prop( `checked`, false );
      } else {
        // $( `.fileupload_bg_options .style3` ).show();
        $( `.fileupload_bg_options .style3` ).removeClass( `hidden` );
      }

      const presignData = await getPresignedUploadUrl(randomName, file.type);
      if ( presignData.url ) {
        originalUploadedFileURL = presignData.sourceUrl;
        const response = await fetch(presignData.url, {
          method: 'PUT',
          body: file
        });

        let filePath = `https://${ninjaImgixHost}/${randomName}`;
        if (isGangPage){
          filePath = `https://${ninjaImgixHost}/${randomName}`;
          document.querySelector("#fileupload_hero").setAttribute('src', filePath+"?h=1000&auto=compress&q=50&fm=png");
        }else{
          document.querySelector("#fileupload_hero").setAttribute('src', `${ filePath }`);
        }

        let file_crc = "";
        try {
          const byteArr = await getAsByteArray(file);
          file_crc = (CRC32.buf(byteArr)>>>0).toString(16);
        }
        catch (error) {
          console.log("Unable to calculate file crc: " + error)
        }

        setTimeout(function(){
          executeNextStep(filePath, true, true, true, randomName, true, file_crc);
        },10)
      }
      else alert('Error uploading file.');
    });

    // Read (file) As Data Url
    fileReader.readAsDataURL(file); 
   // document.querySelector("#fileupload_hero").setAttribute('src', fileReader.path);
  } else { // Else

    this; // (this) Represent The fileValidate(fileType, fileSize) Function

  };
};
/*
$("#option_checkbox").on("click", function(){
  let applicationFiles = $(`input[name="properties[Upload]"]`).val();
  let switchImages = true;
  isFileUpload = false;
  let time = 3000;
  $(".fileupload_bg_options").css({"opacity":0.5,"pointer-events":"none"});
  if ( typeof isAIImage == 'undefined' || typeof isAIImage !== 'undefined' && isAIImage == false ) {
    $( `#bgRemover` ).remove();
  }
  $(".easyzoom").addClass("image-loading");

  if($(this).is(":checked") == true){
    $( `#remove_background` ).prop( `disabled`, false );
    $("#remove_background").val("Yes");
    $(".fileupload_info p strong").html("Cropped size");
    $(".easyzoom,.viewer-box").removeClass("no-bg");
    if(switchImages)
    executeNextStep(applicationFiles, true, true, false, null, false);
  }else{
    $( `#remove_background` ).prop( `disabled`, true );
    $("#remove_background").val("No");
   // $('[href="#custom_size"]').click();
    $(".fileupload_info p strong").html("Original size");
    $(".easyzoom,.viewer-box").addClass("no-bg");
    if(switchImages)
    executeNextStep(applicationFiles, false, false, false, null, false);
  }

  setTimeout(function(){
    // $(".fileupload_bg_options").css({"opacity":1,"pointer-events":"all"});
    // $(".easyzoom").removeClass("image-loading");
  },time)
});

$("#option_checkbox_upscale").on("click", function(){
  let applicationFiles = $(`input[name="properties[Upload]"]`).val();
  let switchImages = true;
  let time = 3000;
  isFileUpload = false;
  const isCustomSizeActive = $( `#size_selection .tab_header a[href="#custom_size"]` ).hasClass( `active` );
  if ( typeof isAIImage == 'undefined' || typeof isAIImage !== 'undefined' && isAIImage == false ) {
    $( `#bgRemover` ).remove();
  }
  const isOptionChecked = $( this ).is( `:checked` );
  console.log ( 'applicationFiles', applicationFiles );
  if ( isOptionChecked ) {
    $( `#super_resolution` ).prop( `disabled`, false );
  } else {
    $( `#super_resolution` ).prop( `disabled`, true );
  }
  if ( isCustomSizeActive && isOptionChecked ) {
    beforeUpScale__Width = $( `.fileupload_preview .horizontal_direction > span` ).text().trim();
    beforeUpScale__height = $( `.fileupload_preview .verticle_direction > span` ).text().trim();
    if ( beforeUpScale__Width.includes( `"` ) ) {
      beforeUpScale__Width = beforeUpScale__Width.replace( `"`, `` );
    }
    beforeUpScale__Width = beforeUpScale__Width * 300;
    if ( beforeUpScale__height.includes( `"` ) ) {
      beforeUpScale__height = beforeUpScale__height.replace( `"`, `` );
    }
    beforeUpScale__height = beforeUpScale__height * 300;
    console.log ( 'beforeUpScale__Width', beforeUpScale__Width );
    console.log ( 'beforeUpScale__height', beforeUpScale__height );
  } else {
    beforeUpScale__Width = 0;
    beforeUpScale__height = 0;
  }
  $(".fileupload_bg_options").css({"opacity":0.5,"pointer-events":"none"});
  $(".easyzoom").addClass("image-loading");
  if($(this).is(":checked") == true){
    $("#super_resolution").val("Yes");
    if(switchImages)
    executeNextStep(applicationFiles, true, true, false, null, false);
  }else{

    $("#super_resolution").val("No");
   // $('[href="#custom_size"]').click();
    if(switchImages)
    executeNextStep(applicationFiles, false, false, false, null, false);
  }

  setTimeout(function(){
    // $(".fileupload_bg_options").css({"opacity":1,"pointer-events":"all"});
    // $(".easyzoom").removeClass("image-loading");
  },time)
})
*/


$("#option_checkbox").on("click", function () {
  const isChecked = $(this).is(":checked");
  const applicationFiles = $('input[name="properties[Upload]"]').val();
  const heroImg = $("#fileupload_hero");
  const viewerImg = $(".viewer-box img");
  const currentSrc = heroImg.attr("src");

  const time = 3000;

  $(".fileupload_bg_options").css({ opacity: 0.5, "pointer-events": "none" });
  $(".easyzoom").addClass("image-loading");

  if (typeof isAIImage === "undefined" || isAIImage === false) {
    $("#bgRemover").remove();
  }
 
  const isPDF = currentSrc.toLowerCase().includes(".pdf");

  let url;

  if (isPDF) {
     
    let baseURL = currentSrc.split("?")[0] + "?fm=png";
    url = new URL(baseURL);
  } else {
    
    url = new URL(currentSrc);
  }
 
  if (isChecked) {
    url.searchParams.set("trim", "colorUnlessAlpha");

    $("#remove_background").prop("disabled", false).val("Yes");
    $(".fileupload_info p strong").text("Cropped size");
    $(".easyzoom, .viewer-box").removeClass("no-bg");
  } else {
    url.searchParams.delete("trim");

    $("#remove_background").prop("disabled", true).val("No");
    $(".fileupload_info p strong").text("Original size");
    $(".easyzoom, .viewer-box").addClass("no-bg");
  }

  const updatedURL = url.toString();

  heroImg.attr("src", updatedURL);
  viewerImg.attr("src", updatedURL);
 
  executeNextStep(updatedURL, true, false, true, null, false);
 
  if (isPDF) {
    heroImg.off("load").on("load", function () {
      const realWidth = this.naturalWidth;
      const realHeight = this.naturalHeight;

      file_width = realWidth;
      file_height = realHeight;
      uploadedFileWidth = realWidth;
      uploadedFileHeight = realHeight;

      const w = (realWidth / 300).toFixed(2);
      const h = (realHeight / 300).toFixed(2);

      $('input[name="width__value"]').val(w);
      $('input[name="height__value"]').val(h);

      $(".fileupload_info p span").html(`${w}" x ${h}"`);

      $('input[name="width__value"], input[name="height__value"]').trigger("keyup");
    });
  }

  setTimeout(() => {
    // keep your existing behavior
    $('input[name="width__value"], input[name="height__value"]').trigger("keyup");

    $(".easyzoom").removeClass("image-loading");
    $(".fileupload_bg_options").css({ opacity: 1, "pointer-events": "auto" });
    addCartImgProperty();
  }, time);
});

function removeParam(urlString, paramToRemove) {
  const url = new URL(urlString);
  url.searchParams.delete(paramToRemove);
  return url.toString();
}
function addParams(urlString, params) {
  const url = new URL(urlString);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value); // use .append() if you want duplicates
  });

  return url.toString();
}

$("#option_checkbox_upscale").on("click", function () {
  const isChecked = $(this).is(":checked");
  const applicationFiles = $('input[name="properties[Upload]"]').val();
  const heroImg = $("#fileupload_hero");
  const viewerImg = $(".viewer-box img");
  const currentSrc = heroImg.attr("src");

  const time = 3000;
  isFileUpload = false;

  const isCustomSizeActive = $('#size_selection .tab_header a[href="#custom_size"]').hasClass("active");

  if (typeof isAIImage === "undefined" || isAIImage === false) {
    $("#bgRemover").remove();
  }

  // Enable / Disable super resolution
  $("#super_resolution")
    .prop("disabled", !isChecked)
    .val(isChecked ? "Yes" : "No");

  // ---- Custom Size Calculation ----
  if (isCustomSizeActive && isChecked) {
    const widthText = $(".fileupload_preview .horizontal_direction > span")
      .text()
      .replace('"', "")
      .trim();

    const heightText = $(".fileupload_preview .verticle_direction > span")
      .text()
      .replace('"', "")
      .trim();

    beforeUpScale__Width = parseFloat(widthText) * 300 || 0;
    beforeUpScale__height = parseFloat(heightText) * 300 || 0;

    console.log("beforeUpScale__Width", beforeUpScale__Width);
    console.log("beforeUpScale__height", beforeUpScale__height);
  } else {
    beforeUpScale__Width = 0;
    beforeUpScale__height = 0;
  }

  // ---- URL Handling (bg-remove param) ----
  const url = new URL(currentSrc);

  if (isChecked) {
    url.searchParams.set("bg-remove", "true");
  } else {
    url.searchParams.delete("bg-remove");
  }

  const updatedURL = url.toString();
  heroImg.attr("src", updatedURL);
  viewerImg.attr("src", updatedURL);

  // ---- UI Loading State ----
  $(".fileupload_bg_options").css({ opacity: 0.5, "pointer-events": "none" });
  $(".easyzoom").addClass("image-loading");

  setTimeout(() => {
    $(".easyzoom").removeClass("image-loading");
    $(".fileupload_bg_options").css({ opacity: 1, "pointer-events": "auto" });
    addCartImgProperty();
  }, time);
});

$( document )
.on(`change`, `#option_checkboxBG`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    if ( typeof isAIImage !== 'undefined' && isAIImage ) {
      let fileURL = $( `#fileupload_hero` ).attr( `src` );
      fileURL = new URL( fileURL );
      fileURL.searchParams.delete( `bg-remove` );
      fileURL.searchParams.delete( `trim` );
      // fileURL = fileURL.replace( `bg-remove=true`, `` );
      const isChecked = $( this ).is( `:checked` );
      $( `#bgRemover` ).remove();
      $( `file-preview preview-block` ).addClass( `image-loading` );
      if ( isChecked ) {
        fileURL.searchParams.set( `bg-remove`, `true` );
        fileURL.searchParams.set( `trim`, `colorUnlessAlpha` );
        $( `#remove_background, #super_resolution` ).prop( `disabled`, true );
        $( `product-form .form` ).append( `<input type="hidden" value="Yes" name="properties[Remove Background]" id="bgRemover">` );
      }
      $( `#fileupload_hero` ).attr( `src`, `${ fileURL.toString() }` );
      $( `.viewer-box img` ).attr( `src`, `${ fileURL.toString() }` );
      const uploadImg = new URL( fileURL );
      uploadImg.searchParams.delete( `fm` );
      $( `[name="properties[Upload]"]` ).val( `${ uploadImg.toString() }` );

      const isImgLoaded = await waitForImageLoad( `#fileupload_hero` );
      console.log ( 'isImgLoaded', isImgLoaded );
      if ( typeof isImgLoaded !== 'undefined' && isImgLoaded ) {
        $( `file-preview preview-block` ).removeClass( `image-loading` );
      }
    }
  } catch ( err ) {
    console.log( `ERROR #option_checkboxBG`, err.message );
  }
})
.on(`focus`, `.customQtyFile__qty`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $(this).select();
  } catch ( err ) {
    console.log( `ERROR .customQtyFile__qty`, err.message );
  }
})
;

async function waitForImageLoad(imgSelector, maxRetries = 5, retryDelay = 3000, attemptTimeout = 10000) {
  const img = document.querySelector(imgSelector);
  if (!img) {
    throw new Error(`No image found with selector "${imgSelector}"`);
  }

  const ignoredSrc = '//cdn.shopify.com/s/files/1/0558/0265/8899/files/transparent.png';
  if (img.src.includes(ignoredSrc)) {
    console.log('Image is transparent placeholder – skipping load check.');
    return null;
  }

  function tryLoadImage(attempt) {
    return new Promise((resolve, reject) => {
      if (img.complete && img.naturalWidth !== 0) {
        return resolve(img);
      }

      let settled = false;
      const timeoutId = setTimeout(() => {
        if (!settled) {
          settled = true;
          cleanup();
          console.warn(`Attempt ${attempt + 1}: image load timed out after ${attemptTimeout}ms`);
          if (attempt < maxRetries) {
            setTimeout(() => {
              tryLoadImage(attempt + 1).then(resolve).catch(reject);
            }, retryDelay);
          } else {
            reject(new Error(`Image timed out after ${maxRetries} attempts.`));
          }
        }
      }, attemptTimeout);

      const onLoad = () => {
        if (!settled) {
          settled = true;
          cleanup();
          clearTimeout(timeoutId);
          resolve(img);
        }
      };

      const onError = () => {
        if (!settled) {
          settled = true;
          cleanup();
          clearTimeout(timeoutId);
          if (attempt < maxRetries) {
            console.warn(`Attempt ${attempt + 1}: image failed to load. Retrying...`);
            setTimeout(() => {
              tryLoadImage(attempt + 1).then(resolve).catch(reject);
            }, retryDelay);
          } else {
            reject(new Error(`Image failed to load after ${maxRetries} attempts.`));
          }
        }
      };

      function cleanup() {
        img.removeEventListener('load', onLoad);
        img.removeEventListener('error', onError);
      }

      img.addEventListener('load', onLoad);
      img.addEventListener('error', onError);
    });
  }

  return tryLoadImage(0);
}

function updateImageSrc(selector, newSrc) {
  const img = $(selector);
  img.on('load', function () {
      console.log('Image has loaded successfully!');
  });

  img.attr('src', newSrc); // Update the src, which triggers the load event
}
// Example usage
// updateImageSrc('#myImage', 'https://example.com/new-image.jpg');


// Progress Counter Increase Function
function progressMove( filePath, fileSize = 550 ) {
 // document.body.classList.remove('upload-cancel');
  let counter = 0;
  if ( fileSize > 9000000 ) {
    fileSize = 250;
  } else if ( fileSize > 7000000 ) {
    fileSize = 150;
  } else if ( fileSize > 5000000 ) {
    fileSize = 120;
  } else if ( fileSize > 3000000 ) {
    fileSize = 90;
  } else if ( fileSize > 1000000 ) {
    fileSize = 80;
  } else {
    fileSize = 70;
  }
  fileSize = 50;
  if(filePath == "quick"){
    counter = 99
  }
  setTimeout(function() {
    if ( window.innerWidth > 500 ) {
      $('html, body').animate({
        scrollTop: ($("#fileupload_custom").offset().top - 150)
      }, 500);
    } else {
      $('html, body').animate({
        scrollTop: ($("#fileupload_custom").offset().top - 10)
      }, 500);
    }
  },500)

  setTimeout(function(){
    let counterIncrease = setInterval(() => {
      if (counter === 100) {
        const isCompleted = $( `.easyzoom` ).hasClass("image-loading");
        if ( isCompleted == false ) {
          clearInterval(counterIncrease);
          document.querySelector(".drop-zoon__icon").style.display = 'none';
          document.querySelector(".drop-zoon__paragraph").style.display = 'none';
          if($('[href="#custom_size"]').hasClass("active") == true){
            $('[href="#custom_size"]').click();
          }
          $(".upload_image_info").removeClass("hidden");

          $(".fileupload_bg_options").css({"opacity":1,"pointer-events":"all"});
          $(".upload-area__file-details").removeClass("file-details--open");
          $("#uploadedFile").removeClass("uploaded-file--open");
        }
      } else {
        counter = counter + 1;
        $(".uploaded_progress_bar, file-progress .fileProgress__bar").css({"width":counter+"%"});
        $( `file-progress .loadingPercent__counter` ).text(`${counter}%`);
        uploadedFileCounter.innerHTML = `${counter}%`
      }
      if ( counter === 99 ) {
        // debugger;
      }
    }, fileSize);
  },100)
};


// Simple File Validate Function
function fileValidate(fileType, fileSize, file) {
  setTimeout(function(){
    $(".secondDropZone,#uploadArea").removeClass("drop-disabled-size");
    $(".secondDropZone,#uploadArea").removeClass("drop-disabled-type");
  },3500)
  // File Type Validation
// alert(fileType);
  let isImage = imagesTypes.filter((type) => fileType.indexOf(`${type}`) !== -1);

  // If The Uploaded File Type Is 'jpeg'
  if (isImage[0] === 'jpeg') {
    // Add Inisde (uploadedFileIconText) The (jpg) Value
    uploadedFileIconText.innerHTML = 'jpg';
  } else { // else
    // Add Inisde (uploadedFileIconText) The Uploaded File Type
    uploadedFileIconText.innerHTML = isImage[0];
  };

  // If The Uploaded File Is An Image
  if (isImage.length !== 0 ) {
    // Check, If File Size Is 2MB or Less
    if (fileSize <= 5368709120) { // 2MB :)
      return true;
    } else { // Else File Size
      $(".secondDropZone,#uploadArea").addClass("drop-disabled-size");
      return false;
    };
  } else { // Else File Type
    $(".secondDropZone,#uploadArea").addClass("drop-disabled-type");
    if(document.querySelector(".file-upload-overlay-2"))
      document.querySelector(".file-upload-overlay-2").classList.remove("active");
      document.querySelector("body").classList.remove("file-upload-overlay-2-active");
    if( document.querySelector(".file-upload-overlay-1"))
      document.querySelector(".file-upload-overlay-1").classList.remove("active");
      document.querySelector("body").classList.remove("file-upload-overlay-1-active");
    return false
  };
};
 
 

function setImageDimensions() {
  try {
    let activeTabIs = '';
    const selectedTab = $( `.tab_header > a[href="#popular_size"].active` ).length;
    if ( selectedTab > 0 ) {
      activeTabIs = 'popular';
    } else {
      activeTabIs = 'custom';
    }

    if ( activeTabIs == 'popular' ) {
      const isRowAvailable = $( `sizes-blocks .widthHeight__custom[option-selected="${ activeTabIs }"]` ).length;
      if ( isRowAvailable > 0 ) {
        let currentSelectedOptionVal = $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .popularSizes` ).val();
        if ( typeof currentSelectedOptionVal !== 'undefined' && currentSelectedOptionVal ) {
          if ( currentSelectedOptionVal.includes( `"` ) ) {
            currentSelectedOptionVal = currentSelectedOptionVal.replaceAll( `"`, `` );
          }
          if ( currentSelectedOptionVal.includes( `^` ) ) {
            currentSelectedOptionVal = currentSelectedOptionVal.replaceAll( `^`, `` );
          }
          if ( currentSelectedOptionVal.includes( ` ` ) ) {
            currentSelectedOptionVal = currentSelectedOptionVal.replaceAll( ` `, `` );
          }
          let getSelectedWidth, getSelectedHeight;
          if ( currentSelectedOptionVal.includes( `x` ) ) {
            getSelectedWidth = currentSelectedOptionVal.split( `x` )[0];
            getSelectedHeight = currentSelectedOptionVal.split( `x` )[1];

            getSelectedWidth = getSelectedWidth * 1;
            getSelectedHeight = getSelectedHeight * 1;

            if ( typeof isPuffProduct !== 'undefined' && isPuffProduct ) {
            } else {
              $( `.fileupload_preview .horizontal_direction span` ).text( `${ getSelectedWidth.toFixed( 2 ) }"` );
              $( `.fileupload_preview .verticle_direction span` ).html( `<b style='display:inline-block;line-height:1;font-size:12px;font-weight: 400;'>Proportional Height</b>` );
              $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, getSelectedWidth.toFixed( 2 ) );
              $( `file-preview .verticle_direction` ).attr( `y-is`, getSelectedHeight.toFixed( 2 ) );
               $( `file-preview .verticle_direction` ).attr( `y-is`, `Proportional Height`);
            }
          }
        }
      } else {
        $( `.fileupload_preview .horizontal_direction span` ).text( `--` );
        $( `.fileupload_preview .verticle_direction span` ).text( `--` );
        $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, `0` );
        $( `file-preview .verticle_direction` ).attr( `y-is`, `0` );
      }
    } else if ( activeTabIs == 'custom' ) {
      const isRowAvailable = $( `sizes-blocks .widthHeight__custom[option-selected="${ activeTabIs }"]` ).length;
      if ( isRowAvailable > 0 ) {
        let getSelectedWidth, getSelectedHeight;
        const isActiveRowAvailable = $( `sizes-blocks .widthHeight__custom[option-selected="${ activeTabIs }"][item="${ selectedItemNo }"]` ).length;
        if ( isActiveRowAvailable > 0 ) {
          getSelectedWidth = $( `sizes-blocks .widthHeight__custom[option-selected="${ activeTabIs }"][item="${ selectedItemNo }"] .widthHeight__item__action[by="width"] .widthHeight__value` ).val() * 1;
          getSelectedHeight = $( `sizes-blocks .widthHeight__custom[option-selected="${ activeTabIs }"][item="${ selectedItemNo }"] .widthHeight__item__action[by="height"] .widthHeight__value` ).val() * 1;

          if ( typeof isPuffProduct !== 'undefined' && isPuffProduct ) {
          } else {
            $( `.fileupload_preview .horizontal_direction span` ).text( `${ getSelectedWidth.toFixed( 2 ) }"` );
            $( `.fileupload_preview .verticle_direction span` ).text( `${ getSelectedHeight.toFixed( 2 ) }"` );

            $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, getSelectedWidth.toFixed( 2 ) );
            $( `file-preview .verticle_direction` ).attr( `y-is`, getSelectedHeight.toFixed( 2 ) );

            
          }
        }
      } else {
        $( `.fileupload_preview .horizontal_direction span` ).text( `--` );
        $( `.fileupload_preview .verticle_direction span` ).text( `--` );
      }
    } else {
      $( `.fileupload_preview .horizontal_direction span` ).text( `--` );
      $( `.fileupload_preview .verticle_direction span` ).text( `--` );
    }
    if ( typeof isBumperStickerProduct !== 'undefined' && isBumperStickerProduct ) {
      getSelectedWidth = $( `sizes-blocks .widthHeight__custom.bumperStickers[item="${ selectedItemNo }"] .popularSizes_sticker` ).attr( `w` ) * 1;
      getSelectedHeight = $( `sizes-blocks .widthHeight__custom.bumperStickers[item="${ selectedItemNo }"] .popularSizes_sticker` ).attr( `h` ) * 1;

      $( `.fileupload_preview .horizontal_direction span` ).text( `${ getSelectedWidth.toFixed( 2 ) }"` );
      $( `.fileupload_preview .verticle_direction span` ).html( `<b style='display:inline-block;line-height:1;font-size:12px;font-weight: 400;'>Proportional Height</b>` );

      $( `file-preview preview-block .horizontal_direction` ).attr( `x-is`, getSelectedWidth.toFixed( 2 ) );
      $( `file-preview .verticle_direction` ).attr( `y-is`, getSelectedHeight.toFixed( 2 ) );

      
    }
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}
 
 

$(".tab_header:not(.upload_files_tab_header) > a").on("click", function(e){
  e.preventDefault();
  $(".tab_header:not(.upload_files_tab_header) > a,.tab_body:not(.upload_files_tab_data) > div").removeClass("active");
  $(this).addClass("active");
  $(".tab_body:not(.upload_files_tab_data) > div"+$(this).attr("href")).addClass("active");
});

$(".tab_header.upload_files_tab_header > a").on("click", function(e){
  e.preventDefault();
  $(".tab_header.upload_files_tab_header > a,.tab_body.upload_files_tab_data > div").removeClass("active");
  $(this).addClass("active");
  $(".tab_body.upload_files_tab_data > div"+$(this).attr("href")).addClass("active");
});

$(".custom-variant-selector").on("change", function(){
  let value = $(this).val();
  $(".product-variant__item.product-variant__item--radio input[value='"+value+"']").click();
});


$("#fileremove-2").click(function() {
  $(".customTabelPopup__overlay-2").fadeIn(500);
  isReadyToPress = false;
});
$(".customTabelPopup__overlay-2 .close").click(function() {
  $(".customTabelPopup__overlay-2").fadeOut(500);
});

closeIcon.addEventListener("click", () => {
 $( `.toast` ).remove();

  setTimeout(() => {
    progress.classList.remove("active");
  }, 300);

  clearTimeout(timer1);
  clearTimeout(timer2);
});
$(".basic_link").on("click", function(e){
  let nextUrl =  $(this).attr("href");
  $("#return_to_url").val(nextUrl)
  e.preventDefault();
  e.stopImmediatePropagation();
  if($(this).data("link") != ""){
    document.body.classList.add("processing-second-upload");
    document.body.classList.add("hide-loader");
    $(".loadingScreen__").css({"opacity":0});
    // $( `.anotherTransfer` ).click();
 //   addAnotherTransfer( `#${ mainSectionID } .product__cart-functions .add-to-cart[data-main-product-add-to-cart]` );
    toast2( `Added`, `Item added successfully` );
  } else {
    $(".customTabelPopup__overlay-6").show();
  }
});

$(".purchase_from_previous").on("click", function(e){
  e.preventDefault();
  e.stopImmediatePropagation();

  $(".customer_designes > img").show();
  $(".customer_designes ul").hide();
  $('.customTabelPopup__overlay-3').fadeIn(500);
  $('.customTabelPopup__overlay-3').attr("data-type",$(this).data("type"));
  $.ajax({
    url: apiURL_+"/uploads/fetchDataNew?customer_id="+CUSTOMER_ID+"&gangsheet="+isGangPage,
    success:function(data){
      $(".customer_designes:not(._2) > img").hide();
      $(".customer_designes:not(._2) ul").show();
      let innerData = "";
      for(let i = 0; i < data.length; i++){
        let variantSize = data[i].variant_title;
        variantSize = variantSize.split("x");

              let file_name = data[i].file;
          // console.log ( 'file_name', file_name );
          if ( file_name.indexOf( `imgix.net` ) > -1 ) {
            file_name = file_name.replace("https://","").split("?")[0].split("/")[1];
            if ( file_name.indexOf("____image") > -1 ) {
              let ext = file_name.split('.').pop()
              file_name =  file_name.split("____image")[0]+"."+ext;
            }
          } else if ( file_name.indexOf( "upload.cloudlift.app" ) > -1 ) {
            file_name =  file_name.split("transferss/")[1];
          } else if ( file_name.indexOf("ninja-services-production") > -1 ) {
            file_name = file_name.replace("https://","").split("?")[0].split("/")[1];
          } else if ( file_name.indexOf("amazonaws") > -1 ) {
            file_name = file_name.replace("https://","").split("?")[0].split("/")[2];
          } 
        let filePathCompressed = data[i].file.replace(ninjaS3Host2,ninjaS3Host);
        if(filePathCompressed.indexOf("?") > -1){
          filePathCompressed = data[i].file+"&h=300&auto=compress&q=10&dpi=72";
        }else{
          filePathCompressed = data[i].file+"?h=300&auto=compress&q=10&dpi=72";
        }
        innerData += `
          <li data-date="${data[i].formatted_date}" data-name="${file_name.toLowerCase()	}"  >
            <div>
              <div class="upload_tools">
                <a href="#" onclick="downloadImage('${data[i].file}','${file_name}')" class="download--btn" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/></svg>
                </a>
                <a href="" data-id="${data[i].photo_id}">
                  <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m4.015 5.494h-.253c-.413 0-.747-.335-.747-.747s.334-.747.747-.747h5.253v-1c0-.535.474-1 1-1h4c.526 0 1 .465 1 1v1h5.254c.412 0 .746.335.746.747s-.334.747-.746.747h-.254v15.435c0 .591-.448 1.071-1 1.071-2.873 0-11.127 0-14 0-.552 0-1-.48-1-1.071zm14.5 0h-13v15.006h13zm-4.25 2.506c-.414 0-.75.336-.75.75v8.5c0 .414.336.75.75.75s.75-.336.75-.75v-8.5c0-.414-.336-.75-.75-.75zm-4.5 0c-.414 0-.75.336-.75.75v8.5c0 .414.336.75.75.75s.75-.336.75-.75v-8.5c0-.414-.336-.75-.75-.75zm3.75-4v-.5h-3v.5z" fill-rule="nonzero"/></svg>
                </a>
              </div>
              <div class="img_container">
                <img src="${filePathCompressed}" />
                <div>
                  <a href="" class="use_design" data-src="${data[i].file}" data-name="${file_name}">Use this Design</a>
                </div>
              </div>
              <div class="img_info">
                <h4>${file_name	}</h4>
                <p>Size: <b>${Number(variantSize[0]).toFixed(2)}x${Number(variantSize[1]).toFixed(2)}</b><br/>
                  ${data[i].purchased_at.replace("Purchased","Uploaded")}
                </p>

              </div>
            </div>
          </li>
        `;
      }
      $(".customer_designes:not(._2) ul").html(innerData);
    },
    error: function(){
      $(".customer_designes:not(._2) > img").hide();
      $(".customer_designes:not(._2) ul").show();
      $(".customer_designes:not(._2) ul").html("<p style='text-align:center'>Sorry! No data found</p>");
    }
  });

  $.ajax({
    url: apiURL_+"/uploads/orderDataNew?store=patches&customer_id="+CUSTOMER_ID+"&gangsheet="+isGangPage,
    success:function(data){
      data = data.data;
      $(".customer_designes._2 > img").hide();
      $(".customer_designes._2 ul").show();
      let innerData = "";
      for(let i = 0; i < data.length; i++){
        let   file_name = data[i].file;
        if(file_name.indexOf("imgix.net") > -1){
          file_name = file_name.replace("https://","").split("?")[0].split("/")[1];
          if(file_name.indexOf("____image") > -1){
            let ext = file_name.split('.').pop()
            file_name =  file_name.split("____image")[0]+"."+ext;
          }
        }else if(file_name.indexOf("upload.cloudlift.app") > -1){
          file_name =  file_name.split("transferss/")[1];
        }else if(file_name.indexOf("ninja-services-production") > -1){
          file_name = file_name.replace("https://","").split("?")[0].split("/")[1];
        }else if(file_name.indexOf("amazonaws") > -1){
          file_name = file_name.replace("https://","").split("?")[0].split("/")[2];
        }
        let variantSize = data[i].variant_title.split(" / ")[0].toLowerCase();
        // variantSize = variantSize.split("x");
        let filePathCompressed = data[i].file.replace(ninjaS3Host2,ninjaS3Host);
        if(filePathCompressed.indexOf("?") > -1){
          filePathCompressed = data[i].file+"&h=300&auto=compress&q=10&dpi=72";
        }else{
          filePathCompressed = data[i].file+"?h=300&auto=compress&q=10&dpi=72";
        }
        innerData += `
          <li data-date="${data[i].formatted_date}" data-photoid="previously on order # ${ data[i].order_name }" data-name="${file_name.toLowerCase()}"  >
            <div>
              <div class="upload_tools">
                <a href="#" onclick="downloadImage('${data[i].file}','${file_name}')"  class="download--btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 21l-8-9h6v-12h4v12h6l-8 9zm9-1v2h-18v-2h-2v4h22v-4h-2z"/></svg>
                </a>
              </div>
              <div class="img_container">
                <img src="${filePathCompressed}" />
                <div>
                  <a href="" class="use_design" data-src="${data[i].file}" data-photoid="previously on order # ${ data[i].order_name }" data-name="${file_name}">Use this Design</a>
                </div>
              </div>
              <div class="img_info">
                <h4>${file_name}</h4>
                <p>Size: <b>${variantSize}</b><br/>
                  ${data[i].purchased_at}
                </p>
              </div>
            </div>
          </li>
        `;
      }
      $(".customer_designes._2 ul").html(innerData);
    },
    error: function(){
      $(".customer_designes._2 > img").hide();
      $(".customer_designes._2 ul").show();
      $(".customer_designes._2 ul").html("<p style='text-align:center'>Sorry! No data found</p>");
    }
  });
});

$("body").on("click", ".customer_designes ul a[data-id]", function(e){
  e.preventDefault();
  $(".customTabelPopup__overlay-4").show();
  $("#fileremove-single").data("id",$(this).data("id"));
});

$("#fileremove-single").on("click", function(){
  let id = $(this).data("id");
  $(".customer_designes ul a[data-id='"+id+"']").parents("li").css({"pointer-events":"none","opacity":0.5});
  $.ajax({
    url: apiURL_+"/uploads/deleteData?customer_id="+CUSTOMER_ID+"&photo_id="+$(this).data("id"),
    success:function(data){
      $(".customer_designes ul a[data-id='"+id+"']").parents("li").remove();
      $(".customTabelPopup__overlay-4").hide();
    }
  });
});

$(".popup_tool_bar input").on("keyup", function(){
  let _this = $(this);
  let value = $(this).val().toLowerCase().trim();
  if(value != ""){
    _this.parents(".image_containers").find(".customer_designes li").show().filter(function() {
      return $(this).text().toLowerCase().trim().indexOf(value) == -1;
    }).hide();
  }else{
    _this.parents(".image_containers").find(".customer_designes li").show();
  }
});

$("body").on("click", ".use_design", function(e){
  e.preventDefault();
  $(".customTabelPopup__overlay-3").hide();
  let datapath = $(this).data("src");
  if($(this).attr(`data-photoid`) != undefined){
    grt_photo_id = $( this ).attr(`data-photoid`);
  }
  console.log("grt_photo_id: ",grt_photo_id,$( this ))
  if(grt_photo_id != ""){
    designtype = 1
  }
  if($(this).parents(".customTabelPopup__overlay-3").attr("data-type") == "second_upload"){
    if ( $( `.loadingScreen__` ).length == 0 ) {
      $( `body` )
      .prepend( `
        <div class="loadingScreen__">
          <img src="${ loaderGif }">
        </div>
      ` );
    }
    // secondryDropZone.classList.add( `secondFileAvailable` );
    document.body.classList.add("processing-second-upload");
    $( `.anotherTransfer` ).click();
   // addAnotherTransfer( `#${ mainSectionID } .product__cart-functions .add-to-cart[data-main-product-add-to-cart]` );
    $("#fileremove").click();
    // field__.clearFiles();

    $( `[name="properties[_Design Notes]"]` ).val( `` );
    toast2( `Added`, `Item added successfully` );
    setTimeout(function(){
      document.body.classList.remove("processing-second-upload");
      $( `.loadingScreen__` ).remove();
    },2000)
  }
  $( `.generative-ai-area` ).addClass( `hidden` );
  dropZoon.classList.add('drop-zoon--Uploaded');
  loadingText.style.display = "block";
  uploadedFile.classList.remove('uploaded-file--open');
  uploadedFileInfo.classList.remove('uploaded-file__info--active');
  uploadArea.classList.add('upload-area--open');
  loadingText.style.display = "none";
  // fileDetails.classList.add('file-details--open');
  // uploadedFile.classList.add('uploaded-file--open');
	uploadedFileInfo.classList.add('uploaded-file__info--active');
	document.querySelector("#fileupload_hero").setAttribute('src', datapath);
	uploadedFileName.innerHTML = $(this).data("name");
	document.querySelector(".fileupload_custom").style.display = "block";
	progressMove("quick",0);
	document.querySelector("#uploadArea").classList.add("hidden");
	executeNextStep(datapath, true, true, false);


  const checkPropertyEle = $( `product-form.product-form form [name="properties[Upload]"]` ).length;
  if ( checkPropertyEle == 0 ) {
    $( `product-form.product-form form` )
      .append( `
        <input type="hidden" name="properties[Upload]" value="${ datapath }">
        <input type="hidden" name="properties[_Original Image]" value="${ datapath.split("?")[0]}">
      ` );

    if(grt_photo_id != ""){
      var design_reuse = $( `input[name="properties[design re-used]"]` ).length
      if(design_reuse > 0){
        $( `input[name="properties[design re-used]"]` ).val(grt_photo_id)
      }else{
        $( `product-form.product-form form` ).append( `<input type="hidden" value="${ grt_photo_id }" name="properties[design re-used]" />` );
      }
    }
  } else {
    $( `product-form.product-form form [name="properties[Upload]"]` ).val( `${ datapath }` );
    $( `product-form.product-form form [name="properties[_Original Image]"]` ).val( `${ datapath.split("?")[0]}` );

    if(grt_photo_id != ""){
      var design_reuse = $( `input[name="properties[design re-used]"]` ).length
      if(design_reuse > 0){
        $( `input[name="properties[design re-used]"]` ).val(grt_photo_id)
      }else{
        $( `product-form.product-form form` ).append( `<input type="hidden" value="${ grt_photo_id }" name="properties[design re-used]" />` );
      }
    }
  }
})

async function downloadImage(imageSrc, file_name) {
  const image = await fetch(imageSrc)
  const imageBlob = await image.blob()
  const imageURL = URL.createObjectURL(imageBlob)

  const link = document.createElement('a')
  link.href = imageURL
  link.download = file_name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

$(".tool_sorting select").on("change", function(){
  let val = $(this).val();
  let _this = $(this);
  _this.parents(".image_containers").find(".customer_designes ul li").sort(function(left, right) {
    if(val == "date_asc")
      return parseInt($(left).attr("data-date")) < parseInt($(right).attr("data-date"));
    else if(val == "date_desc")
      return parseInt($(left).attr("data-date")) > parseInt($(right).attr("data-date"));
    else if(val == "file_name_asc")
      return $(left).attr("data-name") > $(right).attr("data-name") ? 1 : -1;
    else if(val == "file_name_desc")
      return $(left).attr("data-name") < $(right).attr("data-name") ? 1 : -1;
  }).each(function() {
    _this.parents(".image_containers").find(".customer_designes ul").append($(this));
  });
  setTimeout(function(){
    _this.parents(".image_containers").find(".customer_designes").animate({
      scrollTop: (_this.parents(".image_containers").find(".customer_designes").offset().top - 1800)
    }, 0);
  },400)
})

$(".nj-popup").on("click", function(e){
  if (e.target !== this)
    return;
  if($(this).hasClass("customTabelPopup__overlay-ai")){
    document.querySelector('.customTabelPopup__overlay-ai').style.display = 'grid';
    document.querySelector('.customTabelPopup__overlay-12-2').style.display = 'grid';

  }else{
    $(this).hide();
  }
  $("body").removeAttr("style");
  document.querySelector('body').classList.remove("lock-page");
});

$(document).on("click", ".zoom-box,.zoom_image", function (e) {
    // ✅ Don't open popup when clicking Edit-with-AI button or its children

    if ($(this).is("a.zoom_image"))  { }else{

    if ($(e.target).closest(".edit-with-ai").length) return;

    // ✅ Don't open popup when clicking remove icon/link (and similar controls)
    if ($(e.target).closest("a, button, input, textarea, select, label").length) return;
    }
    e.preventDefault();

    if ($(".easyzoom.zoom-box").hasClass("no-bg")) {
      $(".customTabelPopup__overlay-5").removeClass("no-transparant-bg");
    } else {
      $(".customTabelPopup__overlay-5").addClass("no-transparant-bg");
    }

    const getImg = $(`.zoom-box img#fileupload_hero`).attr("src") || $(`.zoom-box .viewer-box img`).attr("src");

    $(".customTabelPopup__overlay-5 img").attr("src", getImg);
    $(".customTabelPopup__overlay-5").show();
  });

addEventListener("DOMContentLoaded", (event) => {
  if(location.search.indexOf("force=upload") > -1){
    if(location.search.indexOf("type=1") > -1){
      location.href = location.href.split("?")[0]+"?force=upload"
    }
    console.log("force=upload");
    setTimeout(function(){
      $("#dropZoon .purchase_from_previous").click();
    },500)
  }
  if(location.search.indexOf("force=login") > -1){
    setTimeout(function(){
      $("#dropZoon .first__upload").click();
    },500)
  }
})

function resetLoading(){
  $("#fileremove").click();
  location.reload();
}

function showAlert(e,cls){
  e.preventDefault();
  $(".warning-message-custom").addClass(cls);
  setTimeout(function(){
    $(".warning-message-custom").removeClass(cls);
    if(cls == "another_alert_by_size"){
      $("[href='#purchased_files_gang_sheet']").removeClass("active");
      $("[href='#purchased_files_by_size']").addClass("active");
    }else{
      $("[href='#purchased_files_gang_sheet']").addClass("active");
      $("[href='#purchased_files_by_size']").removeClass("active");
    }
  },4000);
  return false;
}
$("#fileupload_hero").on("load", function() {
  if($(this).attr("src").indexOf("trim=") > -1){
    let inter =  setInterval(function(){
      if($(".uploaded-file__counter").html() == "100%"){
        const isDataSrcAvailable = $(`preview-block .viewer-box img`).attr(`data-src`);
        if ( typeof isDataSrcAvailable !== 'undefined' && isDataSrcAvailable ) {
          $(`preview-block .viewer-box img`).attr(`src`, isDataSrcAvailable);
          // $(`preview-block .viewer-box img`).removeAttr(`data-src`);
        }
        $(".easyzoom").removeClass("image-loading");
        $(".fileupload_bg_options").css({"opacity":1,"pointer-events":"all"});
        clearInterval(inter);
        setTimeout(() => {
          $( `sizes-blocks .widthHeight__custom[item="${ selectedItemNo }"] .widthHeight__item__action[by="width"] .widthHeight__value` ).trigger('keyup');
        }, 500);
      }
    },100)

  }
});

$(document).on('mouseenter', 'preview-block', function () {

  const $img = $('preview-block .viewer-box img');

  const dataSrc = $img.attr('data-src');

  if (typeof dataSrc !== 'undefined' && dataSrc) {
    $img.attr('src', dataSrc);
    $img.removeAttr('data-src');
  } else {
    $img.attr('src', $(`#fileupload_hero`).attr('src') );
  }

});

function calculateDPI(type = "custom") {
  const isSizesBlock = $( `sizes-blocks` ).length;
  if ( isSizesBlock == 0 && isGangPage == false ) {
    if ( typeof fileExt !== 'undefined' && fileExt ) {
      if ( fileExt == 'png' || fileExt == 'jpg' || fileExt == 'jpeg' ) {

        let physicalWidthInInches = $(`.widthHeight__value[name="width__value"]`).val();
        let physicalHeightInInches = $(`.widthHeight__value[name="height__value"]`).val();
        let makeSqInchesForPopular, makeSqInchesForCustom, currentSqInches = 0;
        if ( type == 'popular' ) {
          if ( typeof isBumperStickerProduct !== 'undefined' && isBumperStickerProduct ) {
            physicalWidthInInches = $( `sizes-blocks .widthHeight__custom.bumperStickers[item="${ selectedItemNo }"] .popularSizes_sticker` ).attr( `w` ) * 1;
            physicalHeightInInches = $( `sizes-blocks .widthHeight__custom.bumperStickers[item="${ selectedItemNo }"] .popularSizes_sticker` ).attr( `h` ) * 1;
          } else {
            physicalWidthInInches =  Number($("popular-wrap input:checked").val().split(" x ")[0].replace('"',''));
            physicalHeightInInches =  Number($("popular-wrap input:checked").val().split(" x ")[1].replace('"',''));
          }

          makeSqInchesForPopular = physicalWidthInInches * physicalHeightInInches;
        } else if ( type == 'custom' ) {
          makeSqInchesForCustom = (uploadedFileWidth * uploadedFileHeight) / 72;
          currentSqInches = ( physicalWidthInInches * physicalHeightInInches ) * 72;
        }

        // Get the pixel dimensions of the image
        const pixelWidth = uploadedFileWidth;
        const pixelHeight = uploadedFileHeight;
        // Calculate DPI
        const dpiWidth = pixelWidth / physicalWidthInInches;
        const dpiHeight = pixelHeight / physicalHeightInInches;
        // console.log(`DPI WIDTH ${uploadedFileWidth} -- ${uploadedFileHeight} -- ${dpiWidth} -- ${dpiHeight}`);
        let dpi =  (parseFloat(dpiWidth) + parseFloat(dpiHeight)) / 2;
        // console.log(`DPI DPI ${dpi} `);
        // console.log(`Maximum recommended size is ${ (uploadedFileWidth / 72).toFixed(2) } x ${ (uploadedFileHeight / 72).toFixed(2) }`);
        if ( type == 'custom' ) {
          if ( makeSqInchesForCustom < 288 ) {
            $(".dpi_warning").addClass("active");
            $( `.dpi_warning recommended-size` ).text( `Maximum recommended size is ${ (uploadedFileWidth / 72).toFixed(2) } x ${ (uploadedFileHeight / 72).toFixed(2) }` );
          } else if ( makeSqInchesForCustom > 288 && makeSqInchesForCustom > currentSqInches ) {
            $(".dpi_warning").removeClass("active");
          } else {
            $(".dpi_warning").addClass("active");
            $( `.dpi_warning recommended-size` ).text( `Maximum recommended size is ${ (uploadedFileWidth / 72).toFixed(2) } x ${ (uploadedFileHeight / 72).toFixed(2) }` );
          }

        } else if ( type == 'popular' ) {
          const recommendedSqInches = ((uploadedFileWidth / 72) * (uploadedFileHeight / 72));
          if ( recommendedSqInches < 4 ) {
            $( `.dpi_warning recommended-size` ).html( `<span style="color: #d00;">Please upload larger size image</span>` );
            $(".dpi_warning").addClass("active");
          } else if ( makeSqInchesForPopular < recommendedSqInches ) {
            $(".dpi_warning").removeClass("active");
          } else {
            $( `.dpi_warning recommended-size` ).text( `Maximum recommended square inches are ${ Math.trunc( recommendedSqInches ) }` );
            $(".dpi_warning").addClass("active");
          }
        } else {
          $( `.dpi_warning recommended-size` ).text( `` );
        }
      }
    }
  }
}


async function refreshAllCart() {
  try {
    isReadyToPress = false;
    const isSecondDropZone = $( `.secondDropZone.secondFileAvailable` ).length;
    if ( isSecondDropZone > 0 ) {
      $( `#site-cart-sidebar.sidebar.sidebar--opened` )
        .find( `.sidebar__close` )
        .click();
      // field__.clearFiles();
      $( `textarea.cl-upload--input` ).val( `` );
      $( `.secondDropZone` ).removeClass( `secondFileAvailable` );
        setTimeout(() => {
        $( `.loadingScreen__` ).remove();
      }, 1500);
    } else {
     // location.href = "?";
      $( `#site-cart-sidebar.sidebar.sidebar--opened` )
        .find( `.sidebar__close` )
        .click();
      $( `.css-slider-dot-navigation .css-slider-dot[data-index="0"]` ).click();
      $( `button.filepond--file-action-button.filepond--action-revert-item-processing` ).click();
      $( `.cl-upload--errors.open` ).remove();
      $( `#size_selection .custom_tabs .tab_header a[href="#custom_size"]` ).click();
    }
    setTimeout(() => {
      anotherTransfer = false;
      $( `#size_selection .custom_tabs .tab_header a[href="#custom_size"]` ).click();
      $( `.loadingScreen__` ).remove();
      if ( typeof reCalculateFreeShippingModule === 'function' ) {
        reCalculateFreeShippingModule();
      }
    }, 1500);
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}
$("body").on("click",".disabled-cta:not(.active)", function(){
  $(".cl-upload--error").css({"display":"block"});
  setTimeout(function(){
    $(".cl-upload--error").css({"display":"none"});
  },5000)
  $( `html, body` ).animate({
    scrollTop: ($( `#uploadArea` ).offset().top - 200)
  }, 1000);
});

const AI_STATES = {
  ORIGINAL: "original",
  PROCESSING: "processing",
  RESULT: "result",
  RESULT_ORG: "result-org"
};

function setAIState(state) {
  const $box = $(".ai-preview-box");

  // Fade transition
  $box.addClass("ai-fade");
  setTimeout(() => $box.removeClass("ai-fade"), 250);

  // Reset UI
  $("#customer_image_preview, #ai_image_preview").hide();
  $(".ai-processing").hide();
  $(".ai-prompt-box").hide();
  $(".ai-action-box").hide();
  $(".ai-tabs").removeClass("active");
  $(".ai-tab").removeClass("active");
  $(".black-bg").hide();
  $(".ai-modal").removeClass("ai-is-processing");
  $(".ai-action-box .button").hide();

  // Tabs reset when needed
  if (state === AI_STATES.ORIGINAL) {
    $('.ai-tab[data-tab="original"]').addClass("active");
    $("#customer_image_preview").show();
    $(".ai-prompt-box").show();
  }

  if (state === AI_STATES.PROCESSING) {
    $(".ai-processing").show();
    $(".ai-modal").addClass("ai-is-processing");
  }

  if (state === AI_STATES.RESULT) {
    $(".ai-tabs").addClass("active");
    $('.ai-tab[data-tab="ai"]').addClass("active");
    $("#ai_image_preview").show();
    $(".ai-action-box").show();
    $(".black-bg").css({"display":"flex"});
    $(".ai-action-box .button#use_ai_image").show();
  }

  if (state === AI_STATES.RESULT_ORG) {
    $(".ai-tabs").addClass("active");
    $('.ai-tab[data-tab="original"]').addClass("active");
    $("#customer_image_preview").show();
    $(".ai-action-box").show();
    $(".black-bg").hide();
    $(".ai-action-box .button:not(#use_ai_image)").show();
  }
}

$(document).on("click", ".ai-tab", function () {

  $(".ai-tab").removeClass("active");
  $(this).addClass("active");

  const tab = $(this).data("tab");

  if (tab === "original") {
    setAIState(AI_STATES.RESULT_ORG);
  }

  if (tab === "ai") {
    setAIState(AI_STATES.RESULT);
  }
});

$("#ai_reset_editor").on("click", function () {
  $("#ai_prompt_2").val("");
  setAIState(AI_STATES.ORIGINAL);
});

let aiJobAbortController = null;
let aiJobCancelled = false;


const AI_DAILY_LIMIT = 50;

function getLocalDayKey() {
  // YYYY-MM-DD in USER'S local timezone
  const d = new Date();
  const year  = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day   = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getAiUsage() {
  const day = getLocalDayKey();
  const raw = localStorage.getItem('nanoBananaUsage');
  let obj = {};
  try { obj = raw ? JSON.parse(raw) : {}; } catch (e) { obj = {}; }

  if (!obj || obj.day !== day) obj = { day, count: 0 };
  return obj;
}

function setAiUsage(obj) {
  localStorage.setItem('nanoBananaUsage', JSON.stringify(obj));
}

function canUseAiRequest() {
  const usage = getAiUsage();
  return usage.count < AI_DAILY_LIMIT;
}

// Call ONLY after API queue request succeeds
function consumeAiRequest() {
  const usage = getAiUsage();
  usage.count = (usage.count || 0) + 1;
  setAiUsage(usage);
  return usage.count;
}

function showRedToast(msg) {
  let $t = $('#ns_ai_toast');
  if (!$t.length) {
    $('body').append(`
      <div id="ns_ai_toast" style="
        position:fixed; left:50%; top:100px; transform:translateX(-50%);
        background:#c62828; color:#fff; padding:12px 16px; border-radius:10px;
        font-size:14px; font-weight:600; z-index:999999; display:none;
        box-shadow:0 10px 30px rgba(0,0,0,.18); max-width:92vw; text-align:center;
      "></div>
    `);
    $t = $('#ns_ai_toast');
  }
  $t.stop(true, true).text(msg).fadeIn(140);
  clearTimeout(window.__nsAiToastTimer);
  window.__nsAiToastTimer = setTimeout(() => $t.fadeOut(200), 3800);
}

function forceOriginalImageToNanoUrlIfAiEdit() {
  try {
    const nanoUrl = (window.__aiEditOriginalUrl || '').trim();
    if (!nanoUrl) return;

    const $form = $(`product-form.product-form form`);
    if (!$form.length) return;

    const $orig = $form.find(`[name="properties[_Original Image]"]`);
    if ($orig.length) {
      $orig.val(nanoUrl);
    } else {
      $form.append(`<input type="hidden" name="properties[_Original Image]" value="${nanoUrl}">`);
    }
  } catch (e) {
    console.log('ERROR forceOriginalImageToNanoUrlIfAiEdit()', e.message);
  }
}

function applyUploadPropertiesToProductForm(datapath, originalUrl, aiEdit) {
  try {
    const $form = $(`product-form.product-form form`);
    if (!$form.length) return;

    const $upload = $form.find(`[name="properties[Upload]"]`);
    const $orig   = $form.find(`[name="properties[_Original Image]"]`);
    const $ai     = $form.find(`[name="properties[AI Edit]"]`);

    if (!$upload.length) {
      $form.append(`
        <input type="hidden" name="properties[Upload]" value="${datapath}">
        <input type="hidden" name="properties[_Original Image]" value="${originalUrl}">
      `);
    } else {
      $upload.val(datapath);
      $orig.val(originalUrl);
    }

    // AI Edit property (add/remove)
    if (aiEdit) {
      if ($ai.length) $ai.val('Yes');
      else $form.append(`<input type="hidden" name="properties[AI Edit]" value="Yes">`);
    } else {
      $ai.remove();
    }
    $("body").removeClass("lock-page");
  } catch (e) {
    console.log('ERROR applyUploadPropertiesToProductForm()', e.message);
  }
}

async function uploadAIUrlToS3AndGetImgix(aiUrl) {
  // 1) download nano-banana image and convert to File
  const resp = await fetch(aiUrl, { cache: 'no-store' });
  if (!resp.ok) throw new Error('Failed to fetch AI image: ' + resp.status);

  const blob = await resp.blob();
  const ext = (blob.type && blob.type.includes('jpeg')) ? 'jpg' : 'png';
  const file = new File([blob], `ai-edit.${ext}`, { type: blob.type || 'image/png' });

  // 2) your existing randomName logic (keep same as you use normally)
  const randomName = (typeof generateRandomName === 'function')
    ? generateRandomName(file.name)
    : (`ai_${Date.now()}_${Math.random().toString(16).slice(2)}.${ext}`);

  // 3) presign + put upload (YOUR SAME PIPELINE)
  const presignData = await getPresignedUploadUrl(randomName, file.type);
  if (!presignData || !presignData.url) throw new Error('Presigned upload URL not returned');

  const originalUploadedFileURL = presignData.sourceUrl; // S3 source url

  const putResp = await fetch(presignData.url, {
    method: 'PUT',
    body: file
  });

  if (!putResp.ok) throw new Error('S3 upload failed: ' + putResp.status);

  // 4) build imgix path (YOUR SAME LOGIC)
  let filePath = `https://${ninjaImgixHost}/${randomName}`;

  // 5) crc if you use it (YOUR SAME LOGIC)
  let file_crc = "";
  try {
    const byteArr = await getAsByteArray(file);
    file_crc = (CRC32.buf(byteArr) >>> 0).toString(16);
  } catch (e) {
    console.log("Unable to calculate file crc:", e);
  }

  // return everything caller needs
  return {
    imgIxFile: filePath,
    s3File: originalUploadedFileURL,
    randomName,
    file_crc
  };
}



function getCurrentPreviewImageUrl() {
  try {
    // When using single upload
    const src1 = $(`file-preview preview-block #fileupload_hero`).attr('src');
    if (src1) return src1;

    // fallback if #fileupload_hero is directly on page
    const src2 = $(`#fileupload_hero`).attr('src');
    if (src2) return src2;

    return '';
  } catch (err) {
    console.log('ERROR getCurrentPreviewImageUrl()', err.message);
    return '';
  }
}

$(document).on("click", "#ai_stop_processing", function () {

  aiJobCancelled = true;

  try {
    if (aiJobAbortController) {
      aiJobAbortController.abort();
    }
  } catch(e){}

  // Reset UI safely
  setAIState(AI_STATES.ORIGINAL);

});

let originalBtnText = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 6.875C8.75 7.04076 8.81585 7.19973 8.93306 7.31694C9.05027 7.43415 9.20924 7.5 9.375 7.5C10.2038 7.5 10.9987 7.82924 11.5847 8.41529C12.1708 9.00134 12.5 9.7962 12.5 10.625C12.5 10.7908 12.5658 10.9497 12.6831 11.0669C12.8003 11.1842 12.9592 11.25 13.125 11.25C13.2908 11.25 13.4497 11.1842 13.5669 11.0669C13.6842 10.9497 13.75 10.7908 13.75 10.625C13.75 9.7962 14.0792 9.00134 14.6653 8.41529C15.2513 7.82924 16.0462 7.5 16.875 7.5C17.0408 7.5 17.1997 7.43415 17.3169 7.31694C17.4342 7.19973 17.5 7.04076 17.5 6.875C17.5 6.70924 17.4342 6.55027 17.3169 6.43306C17.1997 6.31585 17.0408 6.25 16.875 6.25C16.0462 6.25 15.2513 5.92076 14.6653 5.33471C14.0792 4.74866 13.75 3.9538 13.75 3.125C13.75 2.95924 13.6842 2.80027 13.5669 2.68306C13.4497 2.56585 13.2908 2.5 13.125 2.5C12.9592 2.5 12.8003 2.56585 12.6831 2.68306C12.5658 2.80027 12.5 2.95924 12.5 3.125C12.5 3.9538 12.1708 4.74866 11.5847 5.33471C10.9987 5.92076 10.2038 6.25 9.375 6.25C9.20924 6.25 9.05027 6.31585 8.93306 6.43306C8.81585 6.55027 8.75 6.70924 8.75 6.875Z" fill="white"/><path d="M8.125 15C8.125 15.1658 8.19085 15.3247 8.30806 15.4419C8.42527 15.5592 8.58424 15.625 8.75 15.625C9.08152 15.625 9.39946 15.7567 9.63388 15.9911C9.8683 16.2255 10 16.5435 10 16.875C10 17.0408 10.0658 17.1997 10.1831 17.3169C10.3003 17.4342 10.4592 17.5 10.625 17.5C10.7908 17.5 10.9497 17.4342 11.0669 17.3169C11.1842 17.1997 11.25 17.0408 11.25 16.875C11.25 16.5435 11.3817 16.2255 11.6161 15.9911C11.8505 15.7567 12.1685 15.625 12.5 15.625C12.6658 15.625 12.8247 15.5592 12.9419 15.4419C13.0592 15.3247 13.125 15.1658 13.125 15C13.125 14.8342 13.0592 14.6753 12.9419 14.5581C12.8247 14.4408 12.6658 14.375 12.5 14.375C12.1685 14.375 11.8505 14.2433 11.6161 14.0089C11.3817 13.7745 11.25 13.4565 11.25 13.125C11.25 12.9592 11.1842 12.8003 11.0669 12.6831C10.9497 12.5658 10.7908 12.5 10.625 12.5C10.4592 12.5 10.3003 12.5658 10.1831 12.6831C10.0658 12.8003 10 12.9592 10 13.125C10 13.4565 9.8683 13.7745 9.63388 14.0089C9.39946 14.2433 9.08152 14.375 8.75 14.375C8.58424 14.375 8.42527 14.4408 8.30806 14.5581C8.19085 14.6753 8.125 14.8342 8.125 15Z" fill="white"/><path d="M2.5 10.625C2.5 10.7908 2.56585 10.9497 2.68306 11.0669C2.80027 11.1842 2.95924 11.25 3.125 11.25C3.78804 11.25 4.42393 11.5134 4.89277 11.9822C5.36161 12.4511 5.625 13.087 5.625 13.75C5.625 13.9158 5.69085 14.0747 5.80806 14.1919C5.92527 14.3092 6.08424 14.375 6.25 14.375C6.41576 14.375 6.57473 14.3092 6.69194 14.1919C6.80915 14.0747 6.875 13.9158 6.875 13.75C6.875 13.087 7.13839 12.4511 7.60723 11.9822C8.07607 11.5134 8.71196 11.25 9.375 11.25C9.54076 11.25 9.69973 11.1842 9.81694 11.0669C9.93415 10.9497 10 10.7908 10 10.625C10 10.4592 9.93415 10.3003 9.81694 10.1831C9.69973 10.0658 9.54076 10 9.375 10C8.71196 10 8.07607 9.73661 7.60723 9.26777C7.13839 8.79893 6.875 8.16304 6.875 7.5C6.875 7.33424 6.80915 7.17527 6.69194 7.05806C6.57473 6.94085 6.41576 6.875 6.25 6.875C6.08424 6.875 5.92527 6.94085 5.80806 7.05806C5.69085 7.17527 5.625 7.33424 5.625 7.5C5.625 8.16304 5.36161 8.79893 4.89277 9.26777C4.42393 9.73661 3.78804 10 3.125 10C2.95924 10 2.80027 10.0658 2.68306 10.1831C2.56585 10.3003 2.5 10.4592 2.5 10.625Z" fill="white"/></svg><span>Edit Image</span>`;
$(document).ready(function () {
  // ---------- EDIT WITH AI: OPEN POPUP & RESET STATE ----------
  try {
    $("body").on('click', '.edit-with-ai .edit-with-aiFlex', function () {
      if (!canUseAiRequest()) {
        showRedToast('You have reached your AI generation limit for today.');
        return;
      }
      $("body").addClass("lock-page");
      const imgUrl = getCurrentPreviewImageUrl();
      console.log('imgUrl', imgUrl);

      // Set base image preview
      if (imgUrl) {
        $('#customer_image_preview').attr('src', imgUrl);
      } else {
        $('#customer_image_preview').attr('src', '');
      }

      // Reset AI result & status each time popup opens
      $('#ai_image_preview').attr('src', '');
      $('#ai_prompt_2').val('');
      $('#ai_status_message').hide().text('');

      // 1) Reset result container and success class
      $('.ai_result_output').hide();           // keep it hidden by default
      $('.ai-container').removeClass('_success');

      // 2) Reset Generate button (enable again for fresh run)
      const $btn = $('#ai_generate_image_2');
      $btn.prop('disabled', false);
      $btn.data('busy', '0');
      // const originalBtnText = decodeHTML($btn.data('original-text')) || 'Edit Image';
      //  $btn.html(originalBtnText);
      isAIEdit = false;
      aiOriginalUrl = '';
      applyUploadPropertiesToProductForm(
        $(`product-form.product-form form [name="properties[Upload]"]`).val() || '',
        $(`product-form.product-form form [name="properties[_Original Image]"]`).val() || '',
        false
      );
      window.__aiEditOriginalUrl = '';
      const $form = $(`product-form.product-form form`);
      $form.find(`input[name="properties[AI Edit]"]`).remove();
      setAIState(AI_STATES.ORIGINAL);
    });
  } catch (err) {
    console.log('ERROR init Edit-with-AI click handler', err.message);
  }

  // ---------- GENERATE IMAGE WITH NANO-BANANA ----------
  try {
    $(document).on('click', '#ai_generate_image_2', async function () {
      if (!canUseAiRequest()) {
        showRedToast('You have reached your AI generation limit for today.');
        return;
      }
      setAIState(AI_STATES.PROCESSING);
        const $btn = $(this);
        const $aiPrompt_2 = $('#ai_prompt_2');
        const $status = $('#ai_status_message');
        let isSuccess = false;
        $('.ai-container').removeClass('_success');

        try {
          // LOCK POPUP
          $('.customTabelPopup__overlay-ai').addClass('ai-overlay-locked');
          $('.customTabelPopup__overlay-ai').addClass('processing-ai');
          const baseImageUrl = $('#customer_image_preview').attr('src');

          if (!baseImageUrl) {
            alert('No base image found. Please upload an image first.');
            return;
          }

          // PROMPT VALIDATION
          let promptText = ($('#ai_prompt_2').val() || '').trim();
          if (!promptText) {
            $status.show().text('Please enter a prompt to describe how you want to edit the image.');
            $('#ai_prompt_2').focus();
            return;
          }

          // UI: set loading state
          $btn.prop('disabled', true);
          $aiPrompt_2.prop('disabled', true);
          $btn.data('busy', '1');
        //  const originalBtnText = decodeHTML($btn.data('original-text')) || $btn.html();
        //  $btn.data('original-text', originalBtnText);
        //  $btn.text('Generating...');
          $status.hide().text('');

          // Clear previous AI preview
          $('#ai_image_preview').attr('src', '');

          // CALL NANO-BANANA
          const newImageUrl = await nanoBananaEditRequest(baseImageUrl, promptText);

          // Update preview
          $('#ai_image_preview').attr('src', newImageUrl);
          $('.ai_result_output').show();
          $('.ai-container').addClass('_success');
          setAIState(AI_STATES.RESULT);
          isSuccess = true;
        } catch (err) {
          console.log('ERROR #ai_generate_image_2 click', err);
          $status.show().text('Error: ' + (err.message || 'Something went wrong while generating the image.'));
        } finally {
          // UNLOCK POPUP
          $('.customTabelPopup__overlay-ai').removeClass('ai-overlay-locked');
          $('.customTabelPopup__overlay-ai').removeClass('processing-ai');

          if (!isSuccess) {
            $btn.prop('disabled', false);
            $aiPrompt_2.prop('disabled', false);
            $btn.data('busy', '0');
          //  const originalBtnText = decodeHTML($btn.data('original-text')) || 'Edit Image';
           // $btn.html(originalBtnText);
          } else {
            $btn.prop('disabled', true);
            $aiPrompt_2.prop('disabled', false);
            $btn.data('busy', '0');
          //  const originalBtnText = decodeHTML($btn.data('original-text')) || 'Edit Image';
           // $btn.html(originalBtnText);
           // $('#ai_prompt_2').val("");
          }
        }
      });

  } catch (err) {
    console.log('ERROR init ai_generate_image_2 handler', err.message);
  }
});


$(document).on('click', '#use_ai_image', async function () {
  const $btn = $(this);
  const $status = $('#ai_status_message');

  try {
    $('.customTabelPopup__overlay-ai').addClass('ai-overlay-locked');

    const nanoUrl = ($('#ai_image_preview').attr('src') || '').trim();
    if (!nanoUrl) return;

    $(".easyzoom").addClass("image-loading");

    $(`#option_checkbox, #option_checkbox_upscale`).prop('checked', true);

    $(`#remove_background, #super_resolution`)
      .val(`Yes`)
      .prop('disabled', false);

    window.__aiEditOriginalUrl = nanoUrl;  // remember it globally
    isAIEdit = true;
    aiOriginalUrl = nanoUrl;
    //if (typeof isAIImage !== 'undefined') isAIImage = true;

    const btnOriginal = $btn.data('original-text') || $btn.html();
    $btn.data('original-text', btnOriginal);
    $btn.prop('disabled', true).html('Applying...');

    // 1) Upload AI image through your S3 + Imgix pipeline
    const uploaded = await uploadAIUrlToS3AndGetImgix(nanoUrl);

    const imgixUrl = uploaded.imgIxFile;        // ✅ use for hero + upload property
    const file_crc = uploaded.file_crc || '';
    const randomName = uploaded.randomName || '';

    // 2) update hero with imgix only (NOT nano url)
    if (isGangPage) {
      document.querySelector("#fileupload_hero")
        ?.setAttribute('src', imgixUrl + "?h=1000&auto=compress&q=50&fm=png");
    } else {
      document.querySelector("#fileupload_hero")
        ?.setAttribute('src', `${imgixUrl}?fm=png&bg-remove=true&trim=colorUnlessAlpha`);
    }

    // 3) Build toggle params for Upload property (bg-remove/upscale/etc)
    let optionParams = '';
    try {
      if (typeof getToggleOptionParams === 'function') {
        optionParams = getToggleOptionParams() || '';
      }
    } catch (e) {}

    // ✅ Upload property must be IMGIX + params
    const uploadValue = imgixUrl + optionParams;
    applyUploadPropertiesToProductForm(uploadValue, nanoUrl, true);
    // 4) Call your existing step flow (keep SAME signature you use)
    setTimeout(function () {
      const getAppliedParams = getToggleParams( `#fileupload_hero` );
      console.log ( 'getAppliedParams', getAppliedParams );
      executeNextStep(imgixUrl, true, true, true, randomName, true, file_crc, getAppliedParams);

      // ✅ executeNextStep overwrites _Original Image to S3, so force it back to nano
      forceOriginalImageToNanoUrlIfAiEdit();

      // ✅ sometimes executeNextStep updates DOM async again, so do a small delayed re-apply
      setTimeout(forceOriginalImageToNanoUrlIfAiEdit, 50);
      setTimeout(forceOriginalImageToNanoUrlIfAiEdit, 250);
    }, 10);


    // 5) Set form hidden inputs:
    //    Upload => imgix + params
    //    _Original Image => nano-banana URL
    //    AI Edit => Yes
    const $form = $(`product-form.product-form form`);
    if ($form.length) {
      // Upload (Vector Files Preferred)
      const $upload = $form.find(`[name="properties[Upload]"]`);
      if ($upload.length) $upload.val(uploadValue);
      else $form.append(`<input type="hidden" name="properties[Upload]" value="${uploadValue}">`);

      // ✅ Original Image should be nano-banana url (NOT S3)
      const $orig = $form.find(`[name="properties[_Original Image]"]`);
      if ($orig.length) $orig.val(nanoUrl);
      else $form.append(`<input type="hidden" name="properties[_Original Image]" value="${nanoUrl}">`);

      // ✅ AI Edit property
      const aiKey = `properties[AI Edit]`;
      const $ai = $form.find(`input[name="${aiKey}"]`);
      if ($ai.length) $ai.val('Yes');
      else $form.append(`<input type="hidden" name="${aiKey}" value="Yes">`);
    }

    // UI
    $('.ai_result_output').show();
    $('.ai-container').addClass('_success');
    addCartImgProperty();

  } catch (err) {
    console.log('ERROR #use_ai_image click', err);
    $status.show().text('Error: ' + (err.message || 'Something went wrong while applying the AI image.'));
  } finally {
    $('.customTabelPopup__overlay-ai').removeClass('ai-overlay-locked').hide();
    $btn.prop('disabled', false).html($btn.data('original-text') || 'Use Ai Edited Image');
  }
});


function getToggleParams( selector ) {
  try {
    const $el = $(selector);
    if (!$el.length) return '';

    let params = '';
    let srcParam = $el.attr('src');
    if ( srcParam && srcParam.includes('?')) {
      params = srcParam.split('?')[1] || '';
    }
    return params;
  } catch ( err ) {
    console.log( `ERROR getToggleParams`, err.message );
  }
}

async function nanoBananaEditRequest(imageUrl, promptText) {
  aiJobCancelled = false;
  aiJobAbortController = new AbortController();
  const FAL_KEY = 'be8d6227-0af0-4f18-ac79-14111cef50cb:a8a72b50bf97f848e1144bd9c5481f0f';
  const AUTH_HEADER = 'Key ' + FAL_KEY;

  // 1. Submit job to queue
  const queueResponse = await fetch('https://queue.fal.run/fal-ai/nano-banana/edit', {
    method: 'POST',
    headers: {
      'Authorization': AUTH_HEADER,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      prompt: promptText,
      num_images: 1,
      aspect_ratio: 'auto',
      output_format: 'png',
      image_urls: [imageUrl]
    })
  });

  if (!queueResponse.ok) {
    const txt = await queueResponse.text().catch(() => '');
    throw new Error('Failed to queue request (' + queueResponse.status + '): ' + txt);
  }

  const job = await queueResponse.json();

  if (!job.status_url || !job.response_url) {
    console.log('nanoBanana job payload:', job);
    throw new Error('Invalid response from nano-banana queue');
  }

  const statusUrl = job.status_url;
  const resultUrl = job.response_url;

  // 2. Poll status until COMPLETED
  let attempts = 0;
  const maxAttempts = 40; // ~80 seconds if interval = 2000ms

  while (attempts < maxAttempts) {
    attempts++;

    const statusResp = await fetch(statusUrl, {
      method: 'GET',
      headers: {
        'Authorization': AUTH_HEADER
      },
      signal: aiJobAbortController.signal
    });

    if (!statusResp.ok) {
      const txt = await statusResp.text().catch(() => '');
      throw new Error('Failed to fetch status (' + statusResp.status + '): ' + txt);
    }

    const statusJson = await statusResp.json();
    // statuses: IN_QUEUE, IN_PROGRESS, COMPLETED, etc.
    if (statusJson.status === 'COMPLETED') {
      break;
    }

    if (statusJson.status === 'FAILED' || statusJson.status === 'CANCELLED' || statusJson.status === 'ERROR') {
      console.log('nanoBanana status error:', statusJson);
      throw new Error('nano-banana request failed with status: ' + statusJson.status);
    }

    // wait before next poll
    await new Promise((resolve) => setTimeout(resolve, 2000));
  }

  if (aiJobCancelled) {
    throw new Error("AI request cancelled by user");
  }

  // 3. Get final result
  const resultResp = await fetch(resultUrl, {
    method: 'GET',
    headers: {
      'Authorization': AUTH_HEADER
    }
  });

  if (!resultResp.ok) {
    const txt = await resultResp.text().catch(() => '');
    throw new Error('Failed to get result (' + resultResp.status + '): ' + txt);
  }

  const resultJson = await resultResp.json();
  console.log('nanoBanana resultJson:', resultJson);

  // ---- FLEXIBLE IMAGE EXTRACTION ----
  let images = [];

  // Your case: { images: [...] }
  if (Array.isArray(resultJson.images)) {
    images = resultJson.images;
  }

  // Fallbacks if they ever change the shape
  if (!images.length && resultJson.response && Array.isArray(resultJson.response.images)) {
    images = resultJson.response.images;
  }
  if (!images.length && resultJson.data && Array.isArray(resultJson.data.images)) {
    images = resultJson.data.images;
  }
  if (!images.length && resultJson.output && Array.isArray(resultJson.output.images)) {
    images = resultJson.output.images;
  }

  if (!images.length) {
    throw new Error('No images[] array found in nano-banana response');
  }

  const first = images[0] || {};
  const url = first.url || first.image_url || first.data_url || first.uri || '';

  if (!url) {
    console.log('nanoBanana first image object:', first);
    throw new Error('No image URL returned from nano-banana');
  }

  return url;
}



/*! crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	if(typeof DO_NOT_EXPORT_CRC === 'undefined') {
		if('object' === typeof exports) {
			factory(exports);
		} else if ('function' === typeof define && define.amd) {
			define(function () {
				var module = {};
				factory(module);
				return module;
			});
		} else {
			factory(CRC32 = {});
		}
	} else {
		factory(CRC32 = {});
	}
	/*eslint-enable */
	/*jshint ignore:end */
}(function(CRC32) {
  CRC32.version = '1.2.3';
  /*global Int32Array */
  function signed_crc_table() {
    var c = 0, table = new Array(256);

    for(var n =0; n != 256; ++n){
      c = n;
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
      table[n] = c;
    }

    return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
  }

  var T0 = signed_crc_table();
  function slice_by_16_tables(T) {
    var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;

    for(n = 0; n != 256; ++n) table[n] = T[n];
    for(n = 0; n != 256; ++n) {
      v = T[n];
      for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
    }
    var out = [];
    for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
    return out;
  }
  var TT = slice_by_16_tables(T0);
  var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
  var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
  var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
  function crc32_bstr(bstr, seed) {
    var C = seed ^ -1;
    for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
    return ~C;
  }

  function crc32_buf(B, seed) {
    var C = seed ^ -1, L = B.length - 15, i = 0;
    for(; i < L;) C =
      Tf[B[i++] ^ (C & 255)] ^
      Te[B[i++] ^ ((C >> 8) & 255)] ^
      Td[B[i++] ^ ((C >> 16) & 255)] ^
      Tc[B[i++] ^ (C >>> 24)] ^
      Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
      T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
      T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
    L += 15;
    while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
    return ~C;
  }

  function crc32_str(str, seed) {
    var C = seed ^ -1;
    for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
      c = str.charCodeAt(i++);
      if(c < 0x80) {
        C = (C>>>8) ^ T0[(C^c)&0xFF];
      } else if(c < 0x800) {
        C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
      } else if(c >= 0xD800 && c < 0xE000) {
        c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
        C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
      } else {
        C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
        C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
      }
    }
    return ~C;
  }
  CRC32.table = T0;
  // $FlowIgnore
  CRC32.bstr = crc32_bstr;
  // $FlowIgnore
  CRC32.buf = crc32_buf;
  // $FlowIgnore
  CRC32.str = crc32_str;
}));

